export const fullText20211207 = [
  `개인정보 수집 및 이용에 대한 안내`,
  `\n`,
  `　　`,
  `\n`,
  `kt sports 주식회사 (“회사” 또는 “kt sports”라 함)는 이용자의 개인정보를 적극적으로 보호하며 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법, 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하여, 관련 법령에 의거한 개인정보취급방침을 제정하고 이용자 권익 보호에 최선을 다하고 있습니다.`,
  `\n`,
  `회사는 개인정보 취급방침을 통해 회원의 개인정보가 어떤 목적으로 수집되고 있으며 어떻게 보호조치가 되고 있는지 알려 드리며 이는 관련 법령, 지침 및 당사 내부 운영방침의 변경에 따라 변경될 수 있습니다.`,
  `\n`,
  `만약 변경사항이 발생할 경우에는 관련 법령이 정하는 방법에 따라 고지하고 있습니다.`,
  `\n`,
  `본 개인정보취급방침은 회사가 제공하는 kt sports 홈페이지 및 kt sports관련 제반 서비스 (kt sports, kt wiz, kt sonicboom 웹/앱 포함) 이용에 적용되며 다음과 같은 내용을 담고 있습니다`,
  `\n`,
  `　　`,
  `\n`,
  `1. 수집하는 개인정보의 항목 및 수집 방법`,
  `2. 개인정보의 수집 및 이용목적`,
  `3. 개인정보 공유 및 제공`,
  `4. 개인정보의 취급위탁`,
  `5. 개인정보의 제3자 제공`,
  `6. 개인정보의 보유 및 이용기간`,
  `7. 개인정보 파기절차 및 방법`,
  `8. 이용자 및 법정대리인의 권리와 그 행사방법`,
  `9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항`,
  `10. 개인정보의 기술적/관리적 보호 대책`,
  `11. 개인정보관리책임자 및 담당자의 연락처`,
  `12. 홈페이지 및 wizzap 1년간 서비스 미이용자의 개인정보 분리보관 또는 파기`,
  `13. 고지의 의무`,
  `\n`,
  `　　`,
  `\n`,
  `1. 수집하는 개인정보의 항목 및 수집 방법`,
  `\n`,
  `회사는 회원가입, 고객상담, wizzap(App)서비스, 유료서비스 등 각종 다양한 서비스를 제공하기 위해 다음과 같은 개인정보를 수집하고 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 회원가입 과정에서 수집하는 항목`,
  `\n`,
  `- 만14세 이상 회원가입: 아이디, 이름, 생년월일, 성별, 비밀번호, 핸드폰번호, 이메일주소,`,
  `\n`,
  `가입인증정보, 연계정보값(아이핀 CI), 중복확인값(아이핀 DI), IP주소, 인증일시`,
  `    - 만14세 미만 회원가입: 아이디, 보호자 이름, 비밀번호, 핸드폰번호, 이메일주소`,
  `\n`,
  `- 우편번호, 주소, 멤버십동의 여부, 휴대폰 문자메시지 수신동의 여부, 마케팅활용 동의여부`,
  `\n`,
  `제3자 제공 동의여부, 경기장 출입정보, 경기장 입장 일시`,
  `\n`,
  `　　`,
  `\n`,
  `나. 서비스 이용과정이나 사업처리 과정에서 자동으로 생성되어 수집되는 항목`,
  `\n`,
  `- 서비스 이용시간/이용기록, 접속로그, 비밀번호, 이용컨텐츠, 쿠키, 접속IP 정보, 요금청구 및 결제기록/정보, 이용정지기록, 주소, 휴대전화 로그인 인증 시 자동 수집 후 활용되는 휴대전화 번호, 서비스 이용에 대한 플랫폼 구분에 따른 OS, OS 버전 정보, 기기 모델명, 브라우져 정보, 서비스 문의하기를 이용하여 발신된 이메일 주소`,
  `\n`,
  `　　`,
  `\n`,
  `다. 이벤트 응모 과정에서 필요한 개인정보 항목`,
  `\n`,
  `　　- 경품 수령지 외 주소 및 전화번호`,
  `\n`,
  `라. 본인 인증이 필요한 경우 수집하는 항목`,
  `\n`,
  `　　- 이름, 생년월일, 성별, 중복가입 확인 정보, 휴대폰번호`,
  `\n`,
  `마. 유료 서비스 이용 과정에서 결제 정보`,
  `\n`,
  `　　- 신용카드 결제 시: 카드사명, 카드번호 등`,
  `\n`,
  `　　- 휴대전화 결제 시: 이동전화번호, 통신사, 모델명, 결제 승인번호 등`,
  `\n`,
  `　　- 계좌 이체 시: 은행명, 계좌번호, 예금주 성명`,
  `\n`,
  `　　- 스마트 OS 탑재 모바일기기 (Table, PC): 전화번호, 모델명, 기기공유 정보`,
  `\n`,
  `　　- 회사 및 kt 그룹사/협력사/제휴사 멤버십 제휴 할인상품 결제 시:`,
  `\n`,
  `사용권한 및 결제가능 여부 인증을 위한 멤버십 카드번호, 보유 포인트 조회 등`,
  `\n`,
  `　　- 번호정보 안내 등 부가서비스 이용과 관련된 정보, 주소변경서비스 이용과 관련된 정보`,
  `\n`,
  `　　`,
  `\n`,
  `2. 개인정보의 수집 및 이용 목적`,
  `\n`,
  `회사가 개인정보를 수집하는 것은 수집한 정보를 바탕으로 아래와 같이 원활한 서비스 제공을 하기 위한 것이며 보다 나은 서비스 제공을 위함입니다. 단, 회원이 서비스 정보 제공을 원치 않는다는 의사를 명확히 밝히는 경우 정보 제공을 하지 않으며 이 경우 회원에게 정보 미제공으로 인한 불이익이 발생하더라도 회사가 책임지지 않습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산`,
  `\n`,
  `콘텐츠 제공, 특정 맞춤 서비스 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심`,
  `\n`,
  `　　`,
  `\n`,
  `나. 회원관리`,
  `\n`,
  `회원제 서비스 제공, 개인식별, kt sports 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달, 회원탈퇴 의사의 확인`,
  `\n`,
  `　　`,
  `\n`,
  `다. 신규 서비스 개발 및 마케팅•광고에의 활용`,
  `\n`,
  `신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 정보 및 참여기회 제공, 광고성 정보 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계`,
  `\n`,
  `　　`,
  `\n`,
  `3. 개인정보의 공유 및 제공`,
  `\n`,
  `회사는 이용자들의 개인정보를 "2. 개인정보의 수집목적 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만 아래의 경우는 예외로 합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 이용자가 사전에 동의 한 경우`,
  `\n`,
  `나. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
  `\n`,
  `　　`,
  `\n`,
  `4. 개인정보의 취급 위탁`,
  `\n`,
  `회사는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.`,
  `\n`,
  `회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `① 티켓링크`,
  `\n`,
  `- 위탁업무 : 티켓 예매, 유료 회원 결제`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `② 스마트로`,
  `\n`,
  `- 위탁업무 : 상품구매`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `③ KT`,
  `\n`,
  `- 위탁업무 : 고객 포인트 조회`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `④ 헬릭스테크`,
  `\n`,
  `- 위탁업무 : kt sports, kt wiz 홈페이지 운영 관리`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `⑤ NICE평가정보㈜`,
  `\n`,
  `- 위탁업무 : 본인확인`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 해당 업체에서 이미 보유하고 있는 개인정보이기 때문에 별도로 저장하지 않음`,
  `\n`,
  `※ 회사는 회원정보 취급을 위탁 받은 업체가 개인정보 보호와 관련하여 제반의 조치를 취하도록 하고 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `5. 개인정보의 제3자 제공`,
  `\n`,
  `회사는 고객의 사전 동의를 받은 경우에 한하여 고객의 개인정보를 제 3자에게 제공하거나 공유할 수 있습니다. 이 경우에는 제공받거나 공유하는 자가 누구이며, 주된 사업이 무엇인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 개인정보를 제공하거나 공유하는 목적이 무엇인지 등에 대해 고지한 후 이에 대한 동의를 구합니다. 회원가입 시 회원이 제3자에게 정보제공에 동의하지 않는 경우라도 회원가입에는 제한이 없습니다. 다만 아래의 경우에는 예외로 합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `① 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
  `1)`,
  `- 제공받는자: KT`,
  `- 제공목적: 휴대폰 문자메시지 발송`,
  `- 제공항목: 휴대전화번호`,
  `- 보유 및 이용기간: 문자메시지 발송 완료 시까지`,
  `2)`,
  `- 제공받는자: 아이네임즈`,
  `- 제공목적: 이메일 발송`,
  `- 제공항목: 이메일 주소`,
  `- 보유 및 이용기간: 이메일 발송 완료 시까지`,
  `\n`,
  `\n`,
  `　　`,
  `\n`,
  `6. 개인정보의 보유 및 이용기간`,
  `\n`,
  `회사는 수집된 회원의 개인정보 수집 목적 또는 제공 받은 목적이 달성되면 지체 없이 파기함을 원칙으로 합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 회사 내부 방침에 의한 정보보유 사유`,
  `\n`,
  `- 부정이용기록(부정가입, 징계기록 등의 비정상적 서비스 이용 기록) : 1년`,
  `\n`,
  `　보존 이유 : 부정 이용 방지`,
  `\n`,
  `　　`,
  `\n`,
  `나. 관련법령에 의한 정보보유 사유`,
  `\n`,
  `상법, ‘전자상거래 등에서의 소비자보호에 관한 법률’ 등 관련 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 또는 다음 각 호의 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.`,
  `\n`,
  `① 계약 또는 청약철회 등에 관한 기록: 5년`,
  `\n`,
  `　　　　보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `\n`,
  `　`,
  `\n`,
  `② 대금결제 및 재화 등의 공급에 관한 기록: 5년`,
  `\n`,
  `　　　　보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `\n`,
  `③ 전자금융 거래에 관한 기록: 5년`,
  `\n`,
  `　　　　보존 이유 : 전자금융거래법`,
  `\n`,
  `④ 소비자의 불만 또는 분쟁처리에 관한 기록: 3년`,
  `\n`,
  `　　　　보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `\n`,
  `⑤ 웹사이트 방문기록: 3개월`,
  `\n`,
  `　　　　보존 이유 : 통신비밀보호법`,
  `\n`,
  `　　`,
  `\n`,
  `7. 개인정보 파기절차 및 방법`,
  `\n`,
  `회사는 이용자의 개인정보를 원칙적으로 이용목적이 달성되면 지체 없이 파기합니다.`,
  `\n`,
  `회사의 개인정보 파기절차 및 방법은 다음과 같습니다.`,
  `\n`,
  `가. 파기절차`,
  `\n`,
  `- 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.`,
  `\n`,
  `- 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.`,
  `\n`,
  `나. 파기방법`,
  `\n`,
  `- 종이에 출력된 개인정보: 분쇄기로 분쇄하거나 소각.`,
  `\n`,
  `- 전자적 파일 형태로 저장된 개인정보: 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제`,
  `\n`,
  `　　`,
  `\n`,
  `8. 이용자 및 법정대리인의 권리와 그 행사방법`,
  `\n`,
  `가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입 해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.`,
  `\n`,
  `나. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' 등)을, 가입 해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.`,
  `\n`,
  `혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.`,
  `\n`,
  `다. 회원이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항`,
  `\n`,
  `가. 회사는 회원 개개인에게 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 소량의 텍스트 파일로 회원 단말기(PC, 스마트폰, 태블릿 PC 등)의 하드디스크에 저장됩니다.`,
  `\n`,
  `나. 쿠키는 이용자가 웹 사이트에 방문할 경우 하드디스크에 저장되어 있는 쿠키 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다.`,
  `\n`,
  `다. 쿠키는 회원의 단말기를 식별하지만 회원을 개인적으로 식별하지는 않습니다. 회원은 쿠키설치에 대한 선택권을 가지고 있습니다. 회원 단말기의 웹브라우저를 지정함으로써 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다.`,
  `\n`,
  `　　※ 설정방법 예 (인터넷 익스플로어의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 >`,
  `\n`,
  `　　　개인정보> 개인정보취급 수준 설정`,
  `\n`,
  `단, 이용자가 쿠키 설치를 거부하는 경우 로그인이 필요한 일부 서비스 제공에 어려움이 있을 수 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `10. 개인정보의 기술적/관리적 보호 대책`,
  `\n`,
  `회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 최선을 다하고 있으며 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다. 단, 다음의 기술적 대책에도 불구하고 해커의 침입 및 신종 바이러스 침투와 같은 사고 발생 당시의 기술로 예방, 조치할 수 없는 불가항력 사유로 인하여 발생한 개인정보의 분실, 도난, 누출, 변조 또는 훼손에 대하여 회원에게 책임을 지지 않습니다.`,
  `\n`,
  `가. 비밀번호 암호화`,
  `\n`,
  `　회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.`,
  `\n`,
  `나. 해킹 등에 대비한 대책`,
  `\n`,
  `　회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 백신프로그램은 주기적으로 업데이트 되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다. 그리고 해킹 등 외부로부터의 비인가 접근을 통제하기 위하여 침입차단시스템을 설치/운영하고 있으며 서버에 접근은 업무역할에 따라 필요한 최소한의 인원으로 제한하고 있습니다.`,
  `\n`,
  `다. 취급 직원의 최소화 및 교육`,
  `\n`,
  `　회사의 개인정보관련 취급 담당자에 대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `11. 개인정보관리책임자 및 담당자의 연락처`,
  `\n`,
  `회사는 회원이 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보 관리책임자를 다음과 같이 지정하여 관리하고 있으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해 드리고 있습니다.　`,
  `\n`,
  `가. 개인정보 관리 책임자: 이인원(e-mail: inwon.lees@kt.com)`,
  `\n`,
  `나. 개인정보 관리 담당자: 민홍명(e-mail: hm.min@kt.com)`,
  `\n`,
  `다. 문의처: www.kt-sports.co.kr`,
  `\n`,
  `기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.`,
  `\n`,
  `　가. 개인정보침해신고센터 (www.118.or.kr / 국번없이 118)`,
  `\n`,
  `　나. 대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)`,
  `\n`,
  `다. 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 국번없이 182)`,
  `\n`,
  `　　`,
  `\n`,
  `12. 홈페이지 및 wizzap 1년간 서비스 미이용자의 개인정보 분리보관 또는 파기`,
  `회사는 고객의 개인정보 보호를 위하여 홈페이지 및 wizzap 최종 로그인 후 11개월간 로그인 기록이 없는 회원에 대해 문자 서비스를 통해 서비스 해지를 고지하고, 고지일로부터 30일 내에 로그인하지 않을 경우 서비스를 해지하며, 회원의 개인정보를 파기합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `13. 고지의 의무`,
  `\n`,
  `　　`,
  `\n`,
  `본 개인정보취급방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.`,
  `\n`,
  `개인정보 처리방침 개정 이력`,
  `\n`,
  `- 개인정보 처리방침 변경 공고일자: 2021년 11월 30일`,
  `\n`,
  `- 시행일자 : 2021년 12월 07일`,
  `\n`,
  `- 이전 개인정보취급방침 (2021년 05월 06일)`,
  `\n`,
]

export const fullText20210506 = [
  `개인정보 수집 및 이용에 대한 안내`,
  `\n`,
  `　　`,
  `\n`,
  `kt sports 주식회사 (“회사” 또는 “kt sports”라 함)는 이용자의 개인정보를 적극적으로 보호하며 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법, 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하여, 관련 법령에 의거한 개인정보취급방침을 제정하고 이용자 권익 보호에 최선을 다하고 있습니다.`,
  `\n`,
  `회사는 개인정보 취급방침을 통해 회원의 개인정보가 어떤 목적으로 수집되고 있으며 어떻게 보호조치가 되고 있는지 알려 드리며 이는 관련 법령, 지침 및 당사 내부 운영방침의 변경에 따라 변경될 수 있습니다.`,
  `\n`,
  `만약 변경사항이 발생할 경우에는 관련 법령이 정하는 방법에 따라 고지하고 있습니다.`,
  `\n`,
  `본 개인정보취급방침은 회사가 제공하는 kt sports 홈페이지 및 kt sports관련 제반 서비스 (kt sports, kt wiz, kt sonicboom 웹/앱 포함) 이용에 적용되며 다음과 같은 내용을 담고 있습니다`,
  `\n`,
  `　　`,
  `\n`,
  `1. 수집하는 개인정보의 항목 및 수집 방법`,
  `2. 개인정보의 수집 및 이용목적`,
  `3. 개인정보 공유 및 제공`,
  `4. 개인정보의 취급위탁`,
  `5. 개인정보의 제3자 제공`,
  `6. 개인정보의 보유 및 이용기간`,
  `7. 개인정보 파기절차 및 방법`,
  `8. 이용자 및 법정대리인의 권리와 그 행사방법`,
  `9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항`,
  `10. 개인정보의 기술적/관리적 보호 대책`,
  `11. 개인정보관리책임자 및 담당자의 연락처`,
  `12. 홈페이지 및 wizzap 1년간 서비스 미이용자의 개인정보 분리보관 또는 파기`,
  `13. 고지의 의무`,
  `\n`,
  `　　`,
  `\n`,
  `1. 수집하는 개인정보의 항목 및 수집 방법`,
  `\n`,
  `회사는 회원가입, 고객상담, wizzap(App)서비스, 유료서비스 등 각종 다양한 서비스를 제공하기 위해 다음과 같은 개인정보를 수집하고 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 회원가입 과정에서 수집하는 항목`,
  `\n`,
  `- 만14세 이상 회원가입: 아이디, 이름, 생년월일, 성별, 비밀번호, 핸드폰번호, 이메일주소,`,
  `\n`,
  `가입인증정보, 연계정보값(아이핀 CI), 중복확인값(아이핀 DI), IP주소, 인증일시`,
  `\n`,
  `- 만14세 미만 회원가입: 아이디, 보호자 이름, 비밀번호, 핸드폰번호, 이메일주소`,
  `\n`,
  `- 우편번호, 주소, 멤버십동의 여부, 휴대폰 문자메시지 수신동의 여부, 마케팅활용 동의여부,`,
  `\n`,
  `제3자 제공 동의여부, 경기장 출입정보, 경기장 입장 일시`,
  `\n`,
  `　　`,
  `\n`,
  `나. 서비스 이용과정이나 사업처리 과정에서 자동으로 생성되어 수집되는 항목`,
  `　　`,
  `- 서비스 이용시간/이용기록, 접속로그, 비밀번호, 이용컨텐츠, 쿠키, 접속IP 정보, 요금청구 및 결제기록/정보, 이용정지기록, 주소, 신용카드 정보, 휴대전화 로그인 인증 시 자동 수집 후 활용되는 휴대전화 번호, 서비스 이용에 대한 플랫폼 구분에 따른 OS, OS 버전 정보, 기기 모델명, 브라우져 정보, 서비스 문의하기를 이용하여 발신된 이메일 주소`,
  `\n`,
  `　　`,
  `\n`,
  `다. 이벤트 응모 과정에서 필요한 개인정보 항목`,
  `\n`,
  `　　- 경품 수령지 외 주소 및 전화번호`,
  `\n`,
  `라. 본인 인증이 필요한 경우 수집하는 항목`,
  `\n`,
  `　　- 이름, 생년월일, 성별, 중복가입 확인 정보, 휴대폰번호`,
  `\n`,
  `마. 유료 서비스 이용 과정에서 결제 정보`,
  `\n`,
  `　　- 신용카드 결제 시: 카드사명, 카드번호 등`,
  `\n`,
  `　　- 휴대전화 결제 시: 이동전화번호, 통신사, 모델명, 결제 승인번호 등`,
  `\n`,
  `　　- 계좌 이체 시: 은행명, 계좌번호, 예금주 성명`,
  `\n`,
  `　　- 스마트 OS 탑재 모바일기기 (Table, PC): 전화번호, 모델명, 기기공유 정보`,
  `\n`,
  `　　- 회사 및 kt 그룹사/협력사/제휴사 멤버십 제휴 할인상품 결제 시:`,
  `\n`,
  `사용권한 및 결제가능 여부 인증을 위한 멤버십 카드번호, 보유 포인트 조회 등`,
  `\n`,
  `　　- 번호정보 안내 등 부가서비스 이용과 관련된 정보, 주소변경서비스 이용과 관련된 정보`,
  `\n`,
  `2. 개인정보의 수집 및 이용 목적`,
  `\n`,
  `회사가 개인정보를 수집하는 것은 수집한 정보를 바탕으로 아래와 같이 원활한 서비스 제공을 하기 위한 것이며 보다 나은 서비스 제공을 위함입니다. 단, 회원이 서비스 정보 제공을 원치 않는다는 의사를 명확히 밝히는 경우 정보 제공을 하지 않으며 이 경우 회원에게 정보 미제공으로 인한 불이익이 발생하더라도 회사가 책임지지 않습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산`,
  `\n`,
  `콘텐츠 제공, 특정 맞춤 서비스 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심`,
  `\n`,
  `　　`,
  `\n`,
  `나. 회원관리`,
  `\n`,
  `회원제 서비스 제공, 개인식별, kt sports 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달, 회원탈퇴 의사의 확인`,
  `\n`,
  `　　`,
  `\n`,
  `다. 신규 서비스 개발 및 마케팅•광고에의 활용`,
  `\n`,
  `신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 정보 및 참여기회 제공, 광고성 정보 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계`,
  `\n`,
  `　　`,
  `\n`,
  `3. 개인정보의 공유 및 제공`,
  `\n`,
  `회사는 이용자들의 개인정보를 "2. 개인정보의 수집목적 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만 아래의 경우는 예외로 합니다.`,
  `\n`,
  `가. 이용자가 사전에 동의 한 경우`,
  `\n`,
  `나. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
  `\n`,
  `　　`,
  `\n`,
  `4. 개인정보의 취급 위탁`,
  `\n`,
  `회사는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.`,
  `\n`,
  `회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `① 티켓링크`,
  `\n`,
  `- 위탁업무 : 티켓 예매, 유료 회원 결제`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `② 스마트로`,
  `\n`,
  `- 위탁업무 : 상품구매`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `③ KT`,
  `\n`,
  `- 위탁업무 : 고객 포인트 조회`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `④ 헬릭스테크`,
  `\n`,
  `- 위탁업무 : kt sports, kt sonicboom, kt wiz 홈페이지 운영 관리`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `\n`,
  `⑤ NICE평가정보㈜`,
  `\n`,
  `- 위탁업무 : 본인확인`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 해당 업체에서 이미 보유하고 있는 개인정보이기 때문에 별도로 저장하지 않음`,
  `\n`,
  `※ 회사는 회원정보 취급을 위탁 받은 업체가 개인정보 보호와 관련하여 제반의 조치를 취하도록 하고 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `5. 개인정보의 제3자 제공`,
  `\n`,
  `회사는 고객의 사전 동의를 받은 경우에 한하여 고객의 개인정보를 제 3자에게 제공하거나 공유할 수 있습니다. 이 경우에는 제공받거나 공유하는 자가 누구이며, 주된 사업이 무엇인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 개인정보를 제공하거나 공유하는 목적이 무엇인지 등에 대해 고지한 후 이에 대한 동의를 구합니다. 회원가입 시 회원이 제3자에게 정보제공에 동의하지 않는 경우라도 회원가입에는 제한이 없습니다. 다만 아래의 경우에는 예외로 합니다.`,
  `\n`,
  `① 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
  `\n`,
  `　　`,
  `\n`,
  `6. 개인정보의 보유 및 이용기간`,
  `\n`,
  `회사는 수집된 회원의 개인정보 수집 목적 또는 제공 받은 목적이 달성되면 지체 없이 파기함을 원칙으로 합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 회사 내부 방침에 의한 정보보유 사유`,
  `\n`,
  `- 부정이용기록(부정가입, 징계기록 등의 비정상적 서비스 이용 기록) : 1년`,
  `\n`,
  `　보존 이유 : 부정 이용 방지`,
  `\n`,
  `나. 관련법령에 의한 정보보유 사유`,
  `\n`,
  `상법, ‘전자상거래 등에서의 소비자보호에 관한 법률’ 등 관련 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 또는 다음 각 호의 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.`,
  `\n`,
  `① 계약 또는 청약철회 등에 관한 기록: 5년`,
  `\n`,
  `　　　　보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `\n`,
  `　`,
  `\n`,
  `② 대금결제 및 재화 등의 공급에 관한 기록: 5년`,
  `\n`,
  `　　　　보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `\n`,
  `　`,
  `\n`,
  `③ 전자금융 거래에 관한 기록: 5년`,
  `\n`,
  `　　　　보존 이유 : 전자금융거래법`,
  `\n`,
  `　`,
  `\n`,
  `④ 소비자의 불만 또는 분쟁처리에 관한 기록: 3년`,
  `\n`,
  `　　　　보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `\n`,
  `⑤ 웹사이트 방문기록: 3개월`,
  `\n`,
  `　　　　보존 이유 : 통신비밀보호법`,
  `\n`,
  `　　`,
  `\n`,
  `7. 개인정보 파기절차 및 방법`,
  `\n`,
  `회사는 이용자의 개인정보를 원칙적으로 이용목적이 달성되면 지체 없이 파기합니다.`,
  `\n`,
  `회사의 개인정보 파기절차 및 방법은 다음과 같습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `가. 파기절차`,
  `\n`,
  `- 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.`,
  `\n`,
  `- 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `나. 파기방법`,
  `\n`,
  `- 종이에 출력된 개인정보: 분쇄기로 분쇄하거나 소각.`,
  `\n`,
  `- 전자적 파일 형태로 저장된 개인정보: 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제`,
  `\n`,
  `　　`,
  `\n`,
  `8. 이용자 및 법정대리인의 권리와 그 행사방법`,
  `\n`,
  `가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입 해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.`,
  `\n`,
  `나. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' 등)을, 가입 해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.`,
  `\n`,
  `혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.`,
  `\n`,
  `다. 회원이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항`,
  `\n`,
  `가. 회사는 회원 개개인에게 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 소량의 텍스트 파일로 회원 단말기(PC, 스마트폰, 태블릿 PC 등)의 하드디스크에 저장됩니다.`,
  `\n`,
  `나. 쿠키는 이용자가 웹 사이트에 방문할 경우 하드디스크에 저장되어 있는 쿠키 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다.`,
  `\n`,
  `다. 쿠키는 회원의 단말기를 식별하지만 회원을 개인적으로 식별하지는 않습니다. 회원은 쿠키설치에 대한 선택권을 가지고 있습니다. 회원 단말기의 웹브라우저를 지정함으로써 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다.`,
  `\n`,
  `　　※ 설정방법 예 (인터넷 익스플로어의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 >`,
  `\n`,
  `　　　개인정보> 개인정보취급 수준 설정`,
  `\n`,
  `단, 이용자가 쿠키 설치를 거부하는 경우 로그인이 필요한 일부 서비스 제공에 어려움이 있을 수 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `10. 개인정보의 기술적/관리적 보호 대책`,
  `\n`,
  `회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 최선을 다하고 있으며 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다. 단, 다음의 기술적 대책에도 불구하고 해커의 침입 및 신종 바이러스 침투와 같은 사고 발생 당시의 기술로 예방, 조치할 수 없는 불가항력 사유로 인하여 발생한 개인정보의 분실, 도난, 누출, 변조 또는 훼손에 대하여 회원에게 책임을 지지 않습니다.`,
  `\n`,
  `가. 비밀번호 암호화`,
  `\n`,
  `　회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.`,
  `\n`,
  `나. 해킹 등에 대비한 대책`,
  `\n`,
  `　회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 백신프로그램은 주기적으로 업데이트 되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다. 그리고 해킹 등 외부로부터의 비인가 접근을 통제하기 위하여 침입차단시스템을 설치/운영하고 있으며 서버에 접근은 업무역할에 따라 필요한 최소한의 인원으로 제한하고 있습니다.`,
  `\n`,
  `다. 취급 직원의 최소화 및 교육`,
  `\n`,
  `　회사의 개인정보관련 취급 담당자에 대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다.`,
  `\n`,
  `　　`,
  `\n`,
  `11. 개인정보관리책임자 및 담당자의 연락처`,
  `\n`,
  `회사는 회원이 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보 관리책임자를 다음과 같이 지정하여 관리하고 있으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해 드리고 있습니다.　`,
  `\n`,
  `가. 개인정보 관리 책임자: 이인원(e-mail: inwon.lees@kt.com)`,
  `\n`,
  `나. 개인정보 관리 담당자: 민홍명(e-mail: hm.min@kt.com)`,
  `\n`,
  `다. 문의처: www.kt-sports.co.kr`,
  `\n`,
  `기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.`,
  `\n`,
  `　가. 개인정보침해신고센터 (www.118.or.kr / 국번없이 118)`,
  `\n`,
  `　나. 대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)`,
  `\n`,
  `다. 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 국번없이 182)`,
  `\n`,
  `　　`,
  `\n`,
  `12. 홈페이지 및 wizzap 1년간 서비스 미이용자의 개인정보 분리보관 또는 파기`,
  `회사는 고객의 개인정보 보호를 위하여 홈페이지 및 wizzap 최종 로그인 후 11개월간 로그인 기록이 없는 회원에 대해 문자 서비스를 통해 서비스 해지를 고지하고, 고지일로부터 30일 내에 로그인하지 않을 경우 서비스를 해지하며, 회원의 개인정보를 파기합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `13. 고지의 의무`,
  `\n`,
  `　　`,
  `\n`,
  `본 개인정보취급방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.`,
  `\n`,
  `개인정보 취급방침 개정 이력`,
  `\n`,
  `- 개인정보 취급방침 변경 공고일자 : 2021년 04월 29일`,
  `\n`,
  `- 시행일자 : 2021년 05월 06일`,
  `\n`,
  `- 이전 개인정보취급방침 (2019년 11월 01일)`,
  `\n`,
]

export const presentLog = [
  `  본 개인정보취급방침은 회사가 제공하는 kt sports 홈페이지 및 kt sports관련 제반 서비스 (kt sports, kt wiz, kt sonicboom 웹/앱 포함) 이용에 적용되며 다음과 같은 내용을 담고 있습니다`,
  `　　`,
  `\n`,
  `1. 수집하는 개인정보의 항목 및 수집 방법`,
  `2. 개인정보의 수집 및 이용목적`,
  `3. 개인정보 공유 및 제공`,
  `4. 개인정보의 취급위탁`,
  `5. 개인정보의 제3자 제공`,
  `6. 개인정보의 보유 및 이용기간`,
  `7. 개인정보 파기절차 및 방법`,
  `8. 이용자 및 법정대리인의 권리와 그 행사방법`,
  `9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항`,
  `10. 개인정보의 기술적/관리적 보호 대책`,
  `11. 개인정보관리책임자 및 담당자의 연락처`,
  `12. 홈페이지 및 wizzap 1년간 서비스 미이용자의 개인정보 분리보관 또는 파기`,
  `13. 고지의 의무`,
  `　　`,
  `\n`,
  `1. 수집하는 개인정보의 항목 및 수집 방법`,
  `　　`,
  `\n`,
  `회사는 회원가입, 고객상담, wizzap(App)서비스, 유료서비스 등 각종 다양한 서비스를 제공하기 위해 다음과 같은 개인정보를 수집하고 있습니다.`,
  `　　`,
  `\n`,
  `가. 회원가입 과정에서 수집하는 항목`,
  `　　`,
  `\n`,
  `- 만14세 이상 회원가입: 아이디, 이름, 생년월일, 성별, 비밀번호, 핸드폰번호, 이메일주소,`,
  `　　`,
  `\n`,
  `가입인증정보, 연계정보값(아이핀 CI), 중복확인값(아이핀 DI), IP주소, 인증일시`,
  `　　`,
  `\n`,
  `- 만14세 미만 회원가입: 아이디, 보호자 이름, 비밀번호, 핸드폰번호, 이메일주소`,
  `　　`,
  `\n`,
  `- 우편번호, 주소, 멤버십동의 여부, 휴대폰 문자메시지 수신동의 여부, 마케팅활용 동의여부,`,
  `　　`,
  `\n`,
  `제3자 제공 동의여부, 경기장 출입정보, 경기장 입장 일시`,
  `　　`,
  `\n`,
  `나. 서비스 이용과정이나 사업처리 과정에서 자동으로 생성되어 수집되는 항목`,
  `　　`,
  `\n`,
  `- 서비스 이용시간/이용기록, 접속로그, 비밀번호, 이용컨텐츠, 쿠키, 접속IP 정보, 요금청구 및 결제기록/정보, 이용정지기록, 주소, 휴대전화 로그인 인증 시 자동 수집 후 활용되는 휴대전화 번호, 서비스 이용에 대한 플랫폼 구분에 따른 OS, OS 버전 정보, 기기 모델명, 브라우져 정보, 서비스 문의하기를 이용하여 발신된 이메일 주소`,
  `　　`,
  `\n`,
  `　　`,
  `\n`,
  `다. 이벤트 응모 과정에서 필요한 개인정보 항목`,
  `　　`,
  `\n`,
  `- 경품 수령지 외 주소 및 전화번호`,
  `　　`,
  `\n`,
  `라. 본인 인증이 필요한 경우 수집하는 항목`,
  `　　`,
  `\n`,
  `- 이름, 생년월일, 성별, 중복가입 확인 정보, 휴대폰번호`,
  `　　`,
  `\n`,
  `마. 유료 서비스 이용 과정에서 결제 정보`,
  `　　`,
  `\n`,
  `- 신용카드 결제 시: 카드사명, 카드번호 등`,
  `　　`,
  `\n`,
  `- 휴대전화 결제 시: 이동전화번호, 통신사, 모델명, 결제 승인번호 등`,
  `　　`,
  `\n`,
  `- 계좌 이체 시: 은행명, 계좌번호, 예금주 성명`,
  `　　`,
  `\n`,
  `- 스마트 OS 탑재 모바일기기 (Table, PC): 전화번호, 모델명, 기기공유 정보`,
  `　　`,
  `\n`,
  `- 회사 및 kt 그룹사/협력사/제휴사 멤버십 제휴 할인상품 결제 시:`,
  `　　`,
  `\n`,
  `사용권한 및 결제가능 여부 인증을 위한 멤버십 카드번호, 보유 포인트 조회 등`,
  `　　`,
  `\n`,
  `- 번호정보 안내 등 부가서비스 이용과 관련된 정보, 주소변경서비스 이용과 관련된 정보`,
  `　　`,
  `\n`,
  `2. 개인정보의 수집 및 이용 목적`,
  `　　`,
  `\n`,
  `회사가 개인정보를 수집하는 것은 수집한 정보를 바탕으로 아래와 같이 원활한 서비스 제공을 하기 위한 것이며 보다 나은 서비스 제공을 위함입니다. 단, 회원이 서비스 정보 제공을 원치 않는다는 의사를 명확히 밝히는 경우 정보 제공을 하지 않으며 이 경우 회원에게 정보 미제공으로 인한 불이익이 발생하더라도 회사가 책임지지 않습니다.`,
  `　　`,
  `\n`,
  `가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산`,
  `　　`,
  `\n`,
  `콘텐츠 제공, 특정 맞춤 서비스 제공, 물품배송 또는 청구서 등 발송, 본인인증, 구매 및 요금결제, 요금추심`,
  `　　`,
  `\n`,
  `나. 회원관리`,
  `　　`,
  `\n`,
  `회원제 서비스 제공, 개인식별, kt sports 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달, 회원탈퇴 의사의 확인`,
  `　　`,
  `\n`,
  `다. 신규 서비스 개발 및 마케팅•광고에의 활용`,
  `　　`,
  `\n`,
  `신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 정보 및 참여기회 제공, 광고성 정보 제공, 접속빈도 파악, 회원의 서비스이용에 대한 통계`,
  `　　`,
  `\n`,
  `3. 개인정보의 공유 및 제공`,
  `　　`,
  `\n`,
  `회사는 이용자들의 개인정보를 "2. 개인정보의 수집목적 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만 아래의 경우는 예외로 합니다.`,
  `　　`,
  `\n`,
  `가. 이용자가 사전에 동의 한 경우`,
  `　　`,
  `\n`,
  `나. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
  `　　`,
  `\n`,
  `4. 개인정보의 취급 위탁`,
  `　　`,
  `\n`,
  `회사는 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.`,
  `　　`,
  `\n`,
  `회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.`,
  `　　`,
  `\n`,
  `① 티켓링크`,
  `　　`,
  `\n`,
  `- 위탁업무 : 티켓 예매, 유료 회원 결제`,
  `　　`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `　　`,
  `\n`,
  `② 스마트로`,
  `　　`,
  `\n`,
  `- 위탁업무 : 상품구매`,
  `　　`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `　　`,
  `\n`,
  `③ KT`,
  `　　`,
  `\n`,
  `- 위탁업무 : 고객 포인트 조회`,
  `　　`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `　　`,
  `\n`,
  `④ 헬릭스테크`,
  `　　`,
  `\n`,
  `- 위탁업무 : kt sports, kt wiz 홈페이지 운영 관리`,
  `　　`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 회원탈퇴 시 혹은 위탁계약 종료 시까지`,
  `　　`,
  `\n`,
  `⑤ NICE평가정보㈜`,
  `　　`,
  `\n`,
  `- 위탁업무 : 본인확인`,
  `　　`,
  `\n`,
  `- 개인정보 보유 및 이용기간 : 해당 업체에서 이미 보유하고 있는 개인정보이기 때문에 별도로 저장하지 않음`,
  `　　`,
  `\n`,
  `※ 회사는 회원정보 취급을 위탁 받은 업체가 개인정보 보호와 관련하여 제반의 조치를 취하도록 하고 있습니다.`,
  `　　`,
  `\n`,
  `5. 개인정보의 제3자 제공`,
  `　　`,
  `\n`,
  `회사는 고객의 사전 동의를 받은 경우에 한하여 고객의 개인정보를 제 3자에게 제공하거나 공유할 수 있습니다. 이 경우에는 제공받거나 공유하는 자가 누구이며, 주된 사업이 무엇인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 개인정보를 제공하거나 공유하는 목적이 무엇인지 등에 대해 고지한 후 이에 대한 동의를 구합니다. 회원가입 시 회원이 제3자에게 정보제공에 동의하지 않는 경우라도 회원가입에는 제한이 없습니다. 다만 아래의 경우에는 예외로 합니다.`,
  `　　`,
  `\n`,
  `① 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
  `1)`,
  `- 제공받는자: KT`,
  `- 제공목적: 휴대폰 문자메시지 발송`,
  `- 제공항목: 휴대전화번호`,
  `- 보유 및 이용기간: 문자메시지 발송 완료 시까지`,
  `2)`,
  `- 제공받는자: 아이네임즈`,
  `- 제공목적: 이메일 발송`,
  `- 제공항목: 이메일 주소`,
  `- 보유 및 이용기간: 이메일 발송 완료 시까지`,
  `　　`,
  `\n`,
  `　　`,
  `\n`,
  `　　`,
  `\n`,
  `　　`,
  `\n`,
  `6. 개인정보의 보유 및 이용기간`,
  `　　`,
  `\n`,
  `회사는 수집된 회원의 개인정보 수집 목적 또는 제공 받은 목적이 달성되면 지체 없이 파기함을 원칙으로 합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.`,
  `　　`,
  `\n`,
  `가. 회사 내부 방침에 의한 정보보유 사유`,
  `　　`,
  `\n`,
  `- 부정이용기록(부정가입, 징계기록 등의 비정상적 서비스 이용 기록) : 1년`,
  `　　`,
  `\n`,
  `보존 이유 : 부정 이용 방지`,
  `　　`,
  `\n`,
  `나. 관련법령에 의한 정보보유 사유`,
  `　　`,
  `\n`,
  `상법, ‘전자상거래 등에서의 소비자보호에 관한 법률’ 등 관련 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 또는 다음 각 호의 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.`,
  `　　`,
  `\n`,
  `① 계약 또는 청약철회 등에 관한 기록: 5년`,
  `　　`,
  `\n`,
  `보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `　　`,
  `\n`,
  `　　`,
  `\n`,
  `　　`,
  `\n`,
  `② 대금결제 및 재화 등의 공급에 관한 기록: 5년`,
  `　　`,
  `\n`,
  `보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `　　`,
  `\n`,
  `③ 전자금융 거래에 관한 기록: 5년`,
  `　　`,
  `\n`,
  `보존 이유 : 전자금융거래법`,
  `　　`,
  `\n`,
  `④ 소비자의 불만 또는 분쟁처리에 관한 기록: 3년`,
  `　　`,
  `\n`,
  `보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률`,
  `　　`,
  `\n`,
  `⑤ 웹사이트 방문기록: 3개월`,
  `　　`,
  `\n`,
  `보존 이유 : 통신비밀보호법`,
  `　　`,
  `\n`,
  `7. 개인정보 파기절차 및 방법`,
  `　　`,
  `\n`,
  `회사는 이용자의 개인정보를 원칙적으로 이용목적이 달성되면 지체 없이 파기합니다.`,
  `　　`,
  `\n`,
  `회사의 개인정보 파기절차 및 방법은 다음과 같습니다.`,
  `　　`,
  `\n`,
  `가. 파기절차`,
  `　　`,
  `\n`,
  `- 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.`,
  `　　`,
  `\n`,
  `- 동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.`,
  `　　`,
  `\n`,
  `나. 파기방법`,
  `　　`,
  `\n`,
  `- 종이에 출력된 개인정보: 분쇄기로 분쇄하거나 소각.`,
  `　　`,
  `\n`,
  `- 전자적 파일 형태로 저장된 개인정보: 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제`,
  `　　`,
  `\n`,
  `8. 이용자 및 법정대리인의 권리와 그 행사방법`,
  `　　`,
  `\n`,
  `가. 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입 해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.`,
  `　　`,
  `\n`,
  `나. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' 등)을, 가입 해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.`,
  `　　`,
  `\n`,
  `혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.`,
  `　　`,
  `\n`,
  `다. 회원이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.`,
  `　　`,
  `\n`,
  `9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항`,
  `　　`,
  `\n`,
  `가. 회사는 회원 개개인에게 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 소량의 텍스트 파일로 회원 단말기(PC, 스마트폰, 태블릿 PC 등)의 하드디스크에 저장됩니다.`,
  `　　`,
  `\n`,
  `나. 쿠키는 이용자가 웹 사이트에 방문할 경우 하드디스크에 저장되어 있는 쿠키 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다.`,
  `　　`,
  `\n`,
  `다. 쿠키는 회원의 단말기를 식별하지만 회원을 개인적으로 식별하지는 않습니다. 회원은 쿠키설치에 대한 선택권을 가지고 있습니다. 회원 단말기의 웹브라우저를 지정함으로써 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있습니다.`,
  `　　`,
  `\n`,
  `※ 설정방법 예 (인터넷 익스플로어의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 >`,
  `　　`,
  `\n`,
  `개인정보> 개인정보취급 수준 설정`,
  `　　`,
  `\n`,
  `단, 이용자가 쿠키 설치를 거부하는 경우 로그인이 필요한 일부 서비스 제공에 어려움이 있을 수 있습니다.`,
  `　　`,
  `\n`,
  `10. 개인정보의 기술적/관리적 보호 대책`,
  `　　`,
  `\n`,
  `회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 최선을 다하고 있으며 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다. 단, 다음의 기술적 대책에도 불구하고 해커의 침입 및 신종 바이러스 침투와 같은 사고 발생 당시의 기술로 예방, 조치할 수 없는 불가항력 사유로 인하여 발생한 개인정보의 분실, 도난, 누출, 변조 또는 훼손에 대하여 회원에게 책임을 지지 않습니다.`,
  `　　`,
  `\n`,
  `가. 비밀번호 암호화`,
  `　　`,
  `\n`,
  `회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.`,
  `　　`,
  `\n`,
  `나. 해킹 등에 대비한 대책`,
  `　　`,
  `\n`,
  `회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 백신프로그램은 주기적으로 업데이트 되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다. 그리고 해킹 등 외부로부터의 비인가 접근을 통제하기 위하여 침입차단시스템을 설치/운영하고 있으며 서버에 접근은 업무역할에 따라 필요한 최소한의 인원으로 제한하고 있습니다.`,
  `　　`,
  `\n`,
  `다. 취급 직원의 최소화 및 교육`,
  `　　`,
  `\n`,
  `회사의 개인정보관련 취급 담당자에 대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다.`,
  `　　`,
  `\n`,
  `11. 개인정보관리책임자 및 담당자의 연락처`,
  `　　`,
  `\n`,
  `회사는 회원이 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보 관리책임자를 다음과 같이 지정하여 관리하고 있으며 개인정보 관련 문의사항에 신속하고 성실하게 답변해 드리고 있습니다.`,
  `　　`,
  `\n`,
  `가. 개인정보 관리 책임자: 구성완(e-mail: sports.koo@kt.com)`,
  `　　`,
  `\n`,
  `나. 개인정보 관리 담당자: 이하람(e-mail: haram2.lee@kt.com)`,
  `　　`,
  `\n`,
  `다. 문의처: www.kt-sports.co.kr`,
  `　　`,
  `\n`,
  `기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.`,
  `　　`,
  `\n`,
  `가. 개인정보침해신고센터 (www.118.or.kr / 국번없이 118)`,
  `　　`,
  `\n`,
  `나. 대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)`,
  `　　`,
  `\n`,
  `다. 경찰청 사이버테러대응센터 (www.ctrc.go.kr / 국번없이 182)`,
  `　　`,
  `\n`,
  `12. 홈페이지 및 wizzap 1년간 서비스 미이용자의 개인정보 분리보관 또는 파기`,
  `회사는 고객의 개인정보 보호를 위하여 홈페이지 및 wizzap 최종 로그인 후 11개월간 로그인 기록이 없는 회원에 대해 문자 서비스를 통해 서비스 해지를 고지하고, 고지일로부터 30일 내에 로그인하지 않을 경우 서비스를 해지하며, 회원의 개인정보를 파기합니다.`,
  `　　`,
  `\n`,
  `13. 고지의 의무`,
  `　　`,
  `\n`,
  `본 개인정보취급방침의 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.`,
  `　　`,
  `\n`,
  `개인정보 처리방침 개정 이력`,
  `　　`,
  `\n`,
  `- 개인정보 처리방침 변경 공고일자: 2023년 1월 12일`,
  `　　`,
  `\n`,
  `- 시행일자 : 2023년 1월 19일`,
  `　　`,
  `\n`,
  `- 이전 개인정보취급방침 (2021년 11월 30일)`,
]

export const thirdPresentLog = [
  `A.'제3자'는 당해 서비스를 제공하는 사업자ㆍ개인정보업무수탁자ㆍ영업양수인과 그 서비스를 이용하고 있는 정보 주체 이외의 모든 자연인과 법인을 의미하며, kt야구단의 경우에는 제휴계약을 맺은 사업자입니다.`,
  `\n`,
  `　　`,
  `\n`,
  `B.개인정보를 제3자에게 제공하려면 제공받는 자, 제공받는 자의 개인정보 이용목적, 제공하는 개인정보 항목, 제공받는 자의 개인정보 보유 및 이용기간 등을 충분하게 알리고 동의를 얻어야 합니다.`,
  `\n`,
  `　　`,
  `\n`,
  `C.사업자로부터 정보 주체의 개인정보를 제공받은 자는 정보 주체의 별도의 동의가 있거나 다른 법률에 특별한 규정이 있는 경우를 제외하면 개인정보를 제공받은 목적과는 다른 용도로 이용하거나 제3자에게 제공해서는 안됩니다.`,
  `\n`,
  `　　`,
  `\n`,
  ` 1. 티켓링크`,
  `  항목 : 아이디, 성명, 휴대전화번호, 주소, 멤버십카드번호`,
  `  제공목적 : 티켓구매`,
  `\n`,
  `　　`,
  `\n`,
  ` 2. 스마트로`,
  `  항목 : 아이디, 성명, 휴대전화번호, 주소, 멤버십카드번호`,
  `  제공목적 : 상품구매`,
  `\n`,
  `　　`,
  `\n`,
  ` 3.휴대폰 문자메시지 대행사`,
  `  항목 : 휴대전화번호`,
  `  제공목적 : 휴대폰 문자메시지 발송`,
  `\n`,
  `　　`,
  `\n`,
  ` 4.이메일대행사`,
  `  항목 : 이메일주소`,
  `  제공목적 :이메일발송`,
  `\n`,
  `　　`,
  `\n`,
  ` 5.KT`,
  `  항목 : 연계정보값(아이핀 CI)`,
  `  제공목적 : 포인트조회`,
  `\n`,
  `　　`,
  `\n`,
  ` 6. NHN 엔터테인먼트`,
  `  항목 : 아이디, 성명, 휴대전화번호, 주소, 멤버십카드번호`,
  `  제공목적 : 티켓구매`,
]

export const serviceLog20240304 = [
  `제1장 총칙`,
  `\n`,
  `제 1조 [목적]`,
  `이 약관은 주식회사 케이티스포츠(이하 “회사”라 합니다)와 이용고객(이하 “회원”이라고 함)간에 회사가 제공하는 콘텐츠 서비스인 wizzap 서비스(이하 “서비스”라 합니다) 및 제반 서비스를 유선 또는 무선 인터넷 등의 수단으로 이용함에 있어 회사와 회원간의 권리, 이용에 관한 제반 사항과 기타 필요한 사항을 규정하는 것을 목적으로 합니다.`,
  `\n`,
  `제2조 [용어의 정의]`,
  `이 약관에서 사용하는 용어의 정의는 다음 각호와 같습니다.`,
  `1. “이용자”라 함은 회사가 제공하는 서비스에 유선 또는 무선 인터넷 등의 수단으로 접속하여 이 약관에 따라 회사가 제공하는 콘텐츠 및 제반 서비스를 이용하는 간편회원 및 실명회원을 말하며 아래 “회원”의 개념을 포함합니다.`,
  `2. “회원”이라 함은 회사와 서비스 이용계약을 체결하고 아이디(ID)를 부여 받은 이용자로서 회사의 정보를 지속적으로 제공받으며 회사가 제공하는 서비스를 지속적으로 이용할 수 있는 자를 말합니다.`,
  `\n`,
  `3. 간편회원이라 함은 실명인증 절차 없이 이메일 인증 등을 통해 가입한 회원으로, 실명인증이 필요한 서비스(유료회원권 등)를 제외한 일부 서비스 기능만을 제한적으로 이용할 수 있는 자를 말합니다.`,
  `\n`,
  `4. 실명회원이라 함은 본인인증 절차를 거쳐 실명으로 가입한 회원으로 회사가 제공하는 유/무료 서비스를 지속적으로 이용 가능한 자를 말합니다.`,
  `5. “아이디(ID)”라 함은 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 영문자와 숫자의 조합을 의미합니다.`,
  `6. “비밀번호(Password)”라 함은 회원이 부여 받은 아이디(ID)와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합 또는 생체인식정보 등을 말합니다.`,
  `\n`,
  `7. “콘텐츠”라 함은 부호, 문자, 음성, 음향, 이미지 및 영상 등(이들의 복합체를 포함합니다)으로 표현된 자료 또는 정보로서, 그 보존 및 이용에 있어서 효용을 높일 수 있도록 디지털 형태로 제작하거나 처리한 것을 말합니다.`,
  `8. “유료 회원권”이라 함은 전2항의 회원이 일정 금액을 회사에 지불하고 이용할 수 있는 콘텐츠 서비스 또는 상품을 의미합니다.`,
  `9. 본 조 제1항에서 정의된 용어 이외의 용어에 대해서는 관계 법령 및 서비스 별 이용기준에서 정의하는 바에 따릅니다.`,
  `\n`,
  `제3조 [신원정보 등의 제공]`,
  `회사는 이 약관의 내용, 상호, 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호, 모사전송번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호 및 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 온라인 서비스화면에 게시합니다. 다만, 약관은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.`,
  `\n`,
  `제4조 [약관의 게시 등]`,
  `1. 회사는 이 약관을 회원이 그 전부를 인쇄할 수 있고 거래과정에서 해당 약관의 내용을 확인할 수 있도록 기술 조치를 취합니다.`,
  `2. 회사는 이용자가 회사와 이 약관의 내용에 관하여 질의 및 응답할 수 있도록 기술적 장치를 설치합니다.`,
  `3. 회사는 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회, 환불조건 등과 같은 중요한 내용을 이용자가 쉽게 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구합니다.`,
  `\n`,
  `제5조 [약관의 효력 및 변경]`,
  `1. 본 약관의 내용은 회원가입 시 게재되거나 공지된 내용에 회원이 동의함으로써 그 효력이 발생합니다.`,
  `2. 회사는 『콘텐츠산업진흥법』, 『전자상거래 등에서의 소비자보호에 관한 법률』,  『약관의 규제에 관한 법률』 등 관련법령을 위반하지 않는 범위에서 이 약관을 변경할 수 있습니다.`,
  `\n`,
  `3. 제2항에 따라 약관을 변경할 경우, 회사는 시행일 및 변경사유를 명시하여 개정약관을 서비스 초기화면에서 다음 각 호에서 정하는 기간 및 시행일로부터 상당한 기간 동안 공지합니다. 다만, 정당한 사유가 있는 경우, 개정약관 등을 확인할 수 있는 링크 등을 제공할 수 있습니다.`,
  `\n`,
  `   1. 변경하고자 하는 약관의 내용이 중대하거나 회원에게 불리한 경우: 시행일로부터 30일 전부터 시행일까지`,
  `\n`,
  `   2. 제1호에 해당하지 않는 경우: 시행일로부터 7일 전부터 시행일까지`,
  `\n`,
  `4. 제2항에 따라 약관을 변경할 경우에 회사는 회원에게 다음 각 호에서 정하는 기한까지 변경 약관 및 변경사유를 전자우편주소로 전송하고, 동의를 받습니다.`,
  `\n`,
  `   1. 변경하고자 하는 약관의 내용이 중대하거나 회원에게 불리한 경우: 시행일로부터 30일 전까지`,
  `\n`,
  `   2. 제1호에 해당하지 않는 경우: 시행일로부터 7일 전까지`,
  `\n`,
  `5. 회원은 개정된 약관에 대해 동의하지 않을 권리가 있으며, 개정된 약관에 동의하지 않을 경우 이용계약을 해지할 수 있습니다. 회사가 제4항에 따라 고지하면서 『이 기한 내에 변경 약관의 적용에 대해 거절의 의사를 표시하지 않으면 동의한 것으로 간주합니다』라는 사실을 명확히 표시한 경우에 그 기한까지 거절의 의사를 표시하지 않거나 이용계약을 해지하지 않은 경우 변경된 약관을 승인한 것으로 봅니다.`,
  `\n`,
  `\n`,
  `제6조 [약관의 해석 및 약관 외 사항에 대한 규정]`,
  `1. 회사는 이 약관 외에 별도의 이용약관 및 정책(이하 “개별약관등”)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 개별약관등이 우선하여 적용됩니다.`,
  `\n`,
  `2. 이 약관에서 정하지 않은 사항이나 해석에 대해서는 개별약관등 및 관계 법령또는 상관례에 따릅니다.`,
  `\n`,
  `\n`,
  `\n`,
  `제2장 서비스 이용 계약`,
  `\n`,
  `\n`,
  `7조 [이용신청, 승낙 및 거절, 계약의 성립]`,
  `1. 회원이 되고자 희망하는 이용자는 약관의 내용에 대하여 동의를 하고 회원가입신청을 한 후 회사가 이러한 신청에 대하여 승낙함으로써 이용계약이 체결됩니다.`,
  `2. 이용신청자는 본 약관 동의와 함께 회사가 필요로 하는 정보를 정확히 작성하여 제출하고 회사는 이를 심사한 후 승낙함으로써 이용계약이 성립됩니다.`,
  `3. 회사는 다음 각호의 어느 하나에 해당하는 사유가 있는 경우 회원가입신청에 대하여 거절할 수 있습니다.`,
  `  1-1. 이용신청에 필요한 사항을 정확하게 기재하지 않은 경우`,
  `  1-2. 실명이 아니거나 타인의 명의를 이용한 경우(실명회원 가입의 경우)`,
  `  1-3. 이용자 등록 사항을 누락하거나 오기하여 신청하는 경우`,
  `  1-4. 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우`,
  `  1-5. 회원자격을 상실한 자로서 회사가 정한 일정 가입보류 기간이 경과되지 아니한 자`,
  `  1-6. 14세 미만의 자가 법정대리인의 동의를 얻지 않은 경우`,
  `  1-7. 기술 및 설비의 미보유로 인하여 서비스 제공이 가능하지 않은 경우`,
  `  1-8. 기타 이용신청자의 귀책에 의하여 승낙이 불가능하거나, 회사가 별도로 정한 이용신청 기준에 부합되지 아니한 자`,
  `4. 회사는 서비스 관련 설비의 여유가 없거나 기술상 또는 업무상 문제가 있는 경우에는 가입신청의 승낙을 유보하거나 거절할 수 있습니다.`,
  `5. 제3항 또는 제4항에 따라 회원가입 신청에 대하여 유보하거나 거절한 경우 회사는 이를 신청자에게 즉시 알려야 합니다. 다만, 회사가 고의 또는 과실 없이 신청자에게 통지할 수 없는 경우에는 그러하지 않습니다.`,
  `\n`,
  `\n`,
  `제8조 [미성년자의 회원가입에 관한 특칙]`,
  `1. 만 14세 미만의 이용자는 개인정보의 수집 및 이용목적에 대하여 충분히 숙지하고 부모 등 법정대리인의 동의를 얻은 후에 회원가입을 신청하고 본인의 개인정보를 제공하여야 합니다.`,
  `2. 회사는 부모 등 법정대리인의 동의에 대한 확인절차를 거치지 않은 만 14세 미만 이용자의 이용신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다. `,
  `3. 만 14세 미만 이용자의 부모 등 법정대리인은 아동에 대한 개인정보의 열람, 정정, 갱신을 요청하거나 회원가입에 대한 동의를 철회할 수 있으며, 이러한 경우에 회사는 지체 없이 필요한 조치를 취해야 합니다.`,
  `\n`,
  `\n`,
  `제9조 [회원 정보의 수정 및 관리]`,
  `1. 회원은 회원정보확인화면을 통해서 언제든지 개인정보를 열람하고 수정할 수 있으며, 이때 서비스 관리를 위해 필요한 실명 등은 수정이 불가합니다. 개명의 경우 실명 재인증을 통해 변경 가능합니다.`,
  `2. 회원은 수시로 회원가입 신청 시 기재한 사항에 대하여 변경이 되었을 경우, 온라인에서 수정하거나 고객센터 연락 등의 방법으로 회사에 그 사실을 알려야 합니다.`,
  `3. 회사는 제2항에 따라 회원으로부터 변경사항을 통지 받은 경우 지체 없이 이에 따라 개인정보를 변경합니다.`,
  `4. 회사가 제3항에 따라 변경하지 않음으로 인하여 발생한 회원의 손해에 대하여 배상합니다. 다만, 회사가 고의 또는 과실이 없음을 증명한 경우에는 그러하지 않습니다.`,
  `5. 회사는 회원이 제2항에 따라 수정하지 않거나 이의 변경사항을 회사에 알리자 않아 발생한 불이익에 대하여 책임을 지지 않습니다.`,
  `\n`,
  `\n`,
  ` `,
  `\n`,
  `제10조(아이디 및 비밀번호 관리의무 등)`,
  `1. 회원은 자신의 아이디와 비밀번호를 선량한 관리자의 주의의무로 관리하며 제3자에게 이용허락 할 수 없습니다. 다만, 회사가 동의한 경우에는 그러하지 않습니다.`,
  `\n`,
  ` 2. 회원이 제1항 본문을 위반한 경우에 회사는 회원에게 발생한 손해에 대해 책임을 지지 않습니다.`,
  `\n`,
  `3. 회원은 아이디 및 비밀번호가 도용되거나 제3자에 의해 사용되고 있음을 알게 된 경우에 즉시 회사에게 그 사실을 통지하고, 회사의 안내에 따라야 합니다.`,
  `\n`,
  `4. 제3항의 경우, 회원이 회사에게 그 사실을 통지하지 않거나 통지한 경우에도 회사의 안내에 따르지 않아 발생한 회원의 손해에 대해 회사는 책임을 지지 않습니다.`,
  `\n`,
  `5. 회원은 도용 등을 방지하기 위해 주기적으로 비밀번호를 변경하며, 회사는 회원에게 비밀번호의 변경을 권고할 수 있습니다.`,
  `\n`,
  `6. 회사는 회원의 아이디가 개인정보유출 우려가 있거나, 반사회적 행위 및 미풍양속을 저해하거나 회사 및 회사의 운영자로 오인하게 할 수 있도록 사용되는 경우, 아이디의 이용을 제한 할 수 있습니다.`,
  `\n`,
  `제11조 [회원에 대한 통지]`,
  `1. 회사는 별도의 방법을 정하지 않는 한 회원에 대한 통지는 회원이 지정한 전자우편 또는 휴대폰 메세지의 방법에 의합니다.`,
  `\n`,
  `\n`,
  `제12조 [회원자격 제한 및 정지]`,
  `1. 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원의 자격을 제한하거나 정지시킬 수 있습니다. 이 경우 회사는 회원에게 해당 사유를 통지합니다.`,
  `  1-1. 다른 사람이 회사의 서비스를 이용하는 것을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우`,
  ` 1-2. 회사가 금지한 정보(컴퓨터 프로그램 등)의 사용, 송신 또는 게시`,
  `  1-3. 회사 또는 제3자의 저작권 등 지식 재산권에 대한 침해.`,
  `  1-4. 회사 또는 제3자에게의 욕설 및 협박, 명예훼손 및 영업, 서비스이용을 방해하는 행위.`,
  `  1-5. 회사를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우`,
  `  1-6. 회사의 기술적 보호조치를 회피 혹은 무력화 하는 행위.`,
  `  1-7. 회사가 제공하는 서비스를 정상적인 용도 이외 또는 부당한 방법으로 서비스를 이용/악용한 이력이 명백한 경우`,
  `  1-8. 제28조 1항 각호에 해당하는 사항을 위반하였을 경우`,
  `2. 회사가 회원의 자격을 제한 및 정지하는 경우 회원에게 이를 통지합니다. 회원은 통지일 기준 최소 7일의 기간을 정해 소명하고, 그 내용이 정당한 경우 회사는 즉시 회원의 자격을 복구합니다. 단, 회사가 정한 소명기간 동안 소명치 않은 경우 회원의 정지 및 제한에 동의한 것으로 간주합니다.`,
  `\n`,
  ` `,
  `\n`,
  `제13조 [회원탈퇴]`,
  `\n`,
  `1. 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원의 탈퇴를 처리합니다.`,
  `\n`,
  `2. 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원을 탈퇴시킬 수 있습니다. 이 경우 회사는 회원에게 해당 사유를 통지합니다.`,
  `\n`,
  `1-1. 제12조 1항의 사유에 해당하여 회사가 회원의 자격을 제한 및 정지 시킨 후, 동일한 행위가 1회 이상 재발하는 경우`,
  `\n`,
  `1-2. 회원이 구단 서비스를 이용 시 본인 및 동반인의 연령, 회원등급, 티켓 구매 내역 등을 회사에 허위로 제공하고 이로 인해 회원 본인 및 동반인이 금전적/서비스적 이득을 취하거나, 타인에게 불이익을 준 내용이 적발될 경우`,
  `\n`,
  `3. 회사가 회원을 탈퇴하는 경우 회원 등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 통지일 기준 최소 7일의 기간을 정하여 소명하고, 그 내용이 정당한 경우 회사는 즉시 회원의 자격을 복구합니다. 단, 회사가 정한 소명기간 동안 소명치 않은 경우 탈퇴 동의로 간주합니다.`,
  `\n`,
  `4. 회원의 탈퇴일 기준 1개월간 재가입이 불가하며, 재가입이 진행될 경우 회원 가입 시 첫회 제공되는 혜택의 대상에서 제외됩니다.`,
  `\n`,
  `5. 본조 2항에 따른 탈퇴가 반복되는 경우, 회사는 회원의 계정을 중지하거나 해지할 수 있으며, 현재 또는 장래의 모든 또는 일부의 서비스 이용을 거절 할 수 있습니다. 이로 인한 책임은 모두 회원 본인에게 있습니다.`,
  `\n`,
  ` `,
  `\n`,
  `6. 회사는 회원이 탈퇴하거나 회원자격을 상실하는 경우 회원의 개인정보를 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 등 관계법령에서 정한 범위와 절차에 따라 파기합니다.`,
  `\n`,
  `\n`,
  `제14조 [개인정보의 보호]`,
  `회사는 관련법령이 정하는 바에 따라서 회원” 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관해서는 관련법령 및 회사가 정하는 개인정보취급방침에 정한 바에 따릅니다. 다만, 회사의 사이트 이외에 단순 링크사이트, 제휴된 몰의 사이트 등의 경우에는 개인정보취급방침이 적용되지 아니합니다.`,
  `\n`,
  `\n`,
  `제3장 서비스 이용`,
  `\n`,
  `제15조 [서비스의 이용개시]`,
  `  1. 회사는 회원의 이용 신청을 승낙한 때부터 서비스를 개시합니다. 단, 유료 회원권 및 월정액 등 유료 서비스의 경우 회사가 지정하는 수단으로 결제가 완료된 후 이용 가능합니다.`,
  `  2. 회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공지하거나 회원에게 이를 통지합니다.`,
  `\n`,
  `\n`,
  `제16조 [서비스의 중단 및 변경]`,
  `회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 서비스의 전부 또는 일부를 변경할 수 있고, 해당 서비스 초기화면에 관련 사항을 게시합니다. 다만, 유료서비스를 변경하는 경우로서 변경된 내용이 중대하거나 회원에게 불리한 경우에는 이 약관에서 정한 법으로 통지하고, 필요한 경우 이 약관에서 정한 바에 따라 회원에게 보상합니다. `,
  `  `,
  `제17조 [유료 회원권의 이용]`,
  `  1. 회원이 본 약관에 동의한다는 의사표시로써 동의함을 선택함과 함께 회사에 대하여 결제를 통한 이용 신청을 하고 회사가 이를 승낙함으로써 유료 회원권 서비스(이하 “유료회원권”이라 함)에 대한 이용계약이 성립됩니다.`,
  `  2. 회원은 회사가 지정하는 결제수단으로 유료 회원권 결제를 할 수 있습니다. 단, 각종 프로모션이나 이벤트 등을 통하여 발행된 쿠폰을 유료 회원권 결제에 이용할 수 없습니다.`,
  `  3. 실명인증을 완료한 회원이 회사가 지정하는 결제수단으로 유료 회원권을 결제 및 신청 한 경우에만 “유료 회원” 자격이 부여되며, 간편회원(비실명 회원)은 유료 회원권의 결제 및 이용을 할 수 없습니다.`,
  `  4. 회사는 유료 회원권을 이용하고자 하는 회원의 구매(결제)횟수에 대하여 내부정책 및 외부 결제업체(은행사, 카드사 등), 기타 관련 법령의 변경에 따라 회원 당 구매횟수 등의 거래한도를 정할 수 있으며, 회원은 회사가 정한 구매횟수를 초과하는 범위의 결제를 할 수 없습니다.`,
  `  5. 회원이 유료 회원권을 결제함으로 인하여 회사로부터 제공된 무상 혜택은 회사의 정책에 따라 일정 기간 경과 후 자동으로 소멸될 수 있습니다.`,
  `  6. 제공되는 서비스 중 상품이나 온라인 콘텐츠의 경우에는 각 판권소유자의 이용허락 여부에 따라 제공되는 시기가 각각 달라질 수 있습니다.`,
  `  7. 무선 콘텐츠 스트리밍 또는 정보 이용시의 데이터량에 따른 요금은 회사가 별도로 청구하지 않으며, 가입하신 이동통신사가 청구합니다.`,
  `\n`,
  ` `,
  `\n`,
  `\n`,
  `제18조 [결제수단 등]`,
  `1. 회원이 결제를 위하여 이용할 수 있는 지불수단은 다음 각 호와 같습니다.`,
  `  가. 선불카드, 직불카드, 신용카드 등의 각종 카드결제`,
  `  나. 전화 또는 휴대전화 요금합산을 이용한 결제`,
  `  다. 폰 뱅킹, 인터넷 뱅킹, 메일 뱅킹 등의 각종 계좌이체`,
  `  라. 회사와 계약을 맺었거나 회사가 인정한 상품권 또는 회사에서 발행한 쿠폰 교환에 의한 결제`,
  `  마. 기타 전자적 지급방법에 의한 대금지급 등`,
  `2. 회원이 특정 결제 수단을 선택하여 결제하는 경우 개별 결제 수단을 제공하는 각각의 서비스를 통해 결제할 수 있는 한도도 각 서비스 제공사가 정하는 기준에 따르게 됩니다.`,
  `3. 회사의 사정에 따라 특정 결제수단이 추가 되거나 서비스 제공이 중단될 수 있습니다.`,
  `\n`,
  `\n`,
  `제19조 [서비스 이용에 따른 무상혜택 및 유효기간]`,
  `1. 회사는 회원이 서비스 이용에 대한 보답으로 무료티켓 제공, 이벤트 참가 기회 제공 또는 결제액의 비율에 따른 마일리지 적립 등의 무상혜택(이하 “무상혜택등”이라 함)을 제공할 수 있습니다.`,
  `\n`,
  `2. 회사는 회원의 무상혜택등에 대한  금융이자 지급 의무가 없습니다.`,
  `3. 회원은 무상혜택등을 회사가 지정한 서비스 이용 대가의 지불수단으로 사용할 수 있습니다.`,
  `4. 무상혜택등의 제공은 당해년도 1월1일부터 가능하며, 당해년도 12월31일 자동 소멸됩니다.`,
  `5. 이벤트성 무상혜택의 경우는 회사의 정책에 따라 일정 기간이 경과하면 자동으로 소멸될 수 있습니다.`,
  `6. 회원은 무상혜택등을 제3자가 사용하도록 하여서는 안되고, 회사가 허락하지 않은 방법으로 타인에게 양도하거나 타인으로부터 양도 받을 수 없습니다.`,
  `\n`,
  `7. 회원이 무상혜택등을 제3자에게 유료로 판매하거나 무단 양도하여 금전 및 기타 재산상의 이익을 취할 경우 서비스이용약관 제11조, 제12조에 근거하여 회원탈퇴처리될 수 있으며 관계법령에 근거한 손해배상청구 및 형사처벌의 대상이 될 수 있습니다.`,
  `\n`,
  `\n`,
  `\n`,
  `제20조 [유료회원권 서비스 이용계약의 성립 및 승낙의 제한]`,
  `1. “회원”은 본 약관에 동의한다는 의사표시(동의함을 선택)와 함께 “회사”에 대하여 결제를 통한 이용 신청을 하고 “회사”가 이를 승낙함으로써 유료회원권 서비스에 대한 이용계약이 성립합니다.`,
  `2. “회사”는 계약 체결 전에 다음 각 호의 사항에 관하여 “회원”이 정확하게 이해하고 실수 또는 착오 없이 거래할 수 있도록 정보를 제공합니다.`,
  `  가. 해당 유료회원권 서비스 결제의 내용, 가격, 이용기간, 이용방법, 청약철회 및 해지 조건 및 그 방법, 환불에 관한 사항 및 유료서비스의 선택과 관련한 사항`,
  `  나. “콘텐츠”의 이용신청에 관한 확인 또는 “회사”의 확인에 대한 동의`,
  `  다. 결제방법의 선택`,
  `3. “회사”는 “회원”의 이용신청이 다음 각 호에 해당하는 경우에는 승낙하지 않거나 승낙을 유보할 수 있습니다.`,
  `  가. 실명이 아니거나 타인의 명의를 이용한 경우`,
  `  나. 허위의 정보를 기재하거나, “회사”가 제시하는 필수 내용을 기재하지 않은 경우`,
  `  다. 미성년자가 청소년보호법에 의해서 이용이 금지되는 “콘텐츠”를 이용하고자 하는 경우`,
  `  라. 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우`,
  `4. “회사”의 승낙의 의사표시에는 “이용자”의 이용신청에 대한 확인 및 서비스제공 가능여부, 이용신청의 정정, 취소 등에 관한 정보 등을 포함합니다`,
  `\n`,
  `\n`,
  `제21조 [미성년회원의 유료서비스 이용계약에 관한 특칙]`,
  `회사는 만 19세 미만의 미성년회원이 유료 서비스를 이용하고자 하는 경우에 부모 등 법정 대리인의 동의를 얻거나, 계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약체결 전에 고지하는 조치를 취합니다.`,
  `\n`,
  `\n`,
  `제22조 [수신확인통지, 이용신청 변경 및 취소]`,
  `1. 회사는 회원의 유료 서비스 결제 이용신청이 있는 경우 회원에게 수신확인통지를 합니다.`,
  `2. 수신확인통지를 받은 회원은 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 이용신청 변경 및 취소를 요청할 수 있고, 회사는 서비스제공 전에 회원의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 청약철회 등에 관한 회사의 규정에 따릅니다.`,
  `\n`,
  `제23조 [서비스의 이용시간]`,
  `1. 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 회사의 업무상이나 기술상의 이유로 서비스가 일시 중지될 수 있고, 또한 운영상의 목적으로 회사가 정한 기간에는 서비스가 일시 중지될 수 있습니다. 이러한 경우 회사는 사전에 공지함이 원칙이나 불가피한 경우 사후에 공지할 수 있습니다.`,
  `2. 유료 서비스의 경우 서비스를 신청한 시점 또는 서비스별 별도 시작시점부터 이용이 가능합니다.`,
  `3. 회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있거나 서비스별 이용 가능시간을 회사의 정책으로 정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.`,
  `\n`,
  `제24조 [서비스의 변경 및 중지]`,
  `1. 회사는 서비스에 대하여 보다 나은 서비스를 제공하기 위한 목적 또는 운영상, 기술상 불가피한 사유가 발생된 때에는 제공중인 서비스를 본 약관의 사항의 범주 내에서 전부 또는 일부 변경할 수 있으며, 변경될 서비스의 내용 및 시행일자를 일정기간 초기화면에 공개하도록 합니다.`,
  `2. 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있으며, 그 내용을 사전에 회원에게 고지하거나, 사전 고지가 어려운 사항일 경우 사후에 고지할 수 있습니다.`,
  `  가. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우`,
  `  나. 정기점검 등의 콘텐츠 서비스의 제공에 필요한 경우`,
  `  다. 서비스 업그레이드 및 사이트 유지보수 등을 위해 필요한 경우`,
  `  라. 회원이 회사의 영업활동을 방해하는 경우`,
  `  마. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우`,
  `  바. 영상, 기록 등 각종 컨텐츠 등의 원 저작권자와의 계약 종료 등 서비스 제공을 위한 원천 데이터 확보가 어려운 경우`,
  `  사. 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우`,
  `\n`,
  `제25조 [서비스의 이용 및 저장]`,
  `1. 회사는 서비스의 이용에 관하여 본 약관 외에 게시물 등의 관리정책을 별도로 둘 수 있으며, 이를 통해 게시물 또는 기타 게재된 내용이 서비스에 의해 보유되는 최대 일수 및 용량, “서비스” 서버에 할당되는 최대 디스크 공간 및 정해진 기간 동안 서비스에 접속할 수 있는 최대한의 수 (최대 기간) 등을 관리할 수 있습니다.`,
  `2. 회사의 정책에도 불구하고 회사의 귀책사유 없이 전 제1항의 정책에 따라 서비스에 보관되는 게시물 또는 기타 게재된 내용 등을 삭제하거나 저장하지 못한데 대해 회사는 아무런 책임을 지지 않습니다.`,
  `3. 회사는 본 이용약관에 따른 서비스의 제공지역을 대한민국으로 한정할 수 있으며, 회원 또는 이용자가 유무선 인터넷을 이용하여 접속 가능한 지역은 대한민국 영토 내로 제한 받을 수 있습니다.`,
  `\n`,
  `제26조 [정보 및 광고의 제공]`,
  `1. 회사는 회원의 서비스 이용과 관련하여 필요한 정보를 서비스 홈페이지에 게재하거나 우편물, e-mail 및 휴대폰 문자메시지 등을 통해 제공할 수 있습니다. 단, 회원이 정보제공을 원치 않는다는 의사를 밝히는 경우 정보제공대상에서 해당 회원을 제외하며, 정보제공 대상에서 제외되어 정보를 제공받지 못해 불이익이 발생할 경우에는 회사는 이에 대한 책임을 지지 않습니다.`,
  `2. 이때 회사는 정보와 함께 특정 광고를 게재할 수 있으며, 광고 수신을 원하지 않을 경우 수신거부를 할 수 있습니다. 그러나 회원이 광고를 통한 제3의 서비스를 이용하는 것과 관련하여 발생하는 모든 문제에 대해서 회사는 어떠한 책임도 지지 않습니다.`,
  `\n`,
  `\n`,
  `제4장 계약당사자의 의무`,
  `\n`,
  `제27조 [회사의 의무]`,
  `1. 회사는 회원의 개인정보를 보호하고 보안시스템을 구비하여 회원이 안전하게 서비스를 이용할 수 있도록 제반 환경을 제공합니다.`,
  `2. 회사는 제 ①항의 범위 내에서 업무와 관련하여 회원의 사전 동의 없이 회원전체 또는 일부의 개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있고, 이를 위하여 회원의 컴퓨터에 쿠키를 전송할 수 있습니다. 이 경우 회원은 쿠키의 수신을 거부하거나 쿠키의 수신에 대하여 경고하도록 사용하는 컴퓨터의 브라우저의 설정을 변경할 수 있습니다.`,
  `3. 회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 신속하게 처리하여야 하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 서비스 화면에 게재하거나 전자우편 등을 통하여 동 회원에게 통지합니다.`,
  `4. 회사는 『정보통신망 이용촉진 및 정보보호에 관한 법률』, 『통신비밀보호법』, 『전기통신사업법』 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.`,
  `\n`,
  `제28조 [회원의 의무]`,
  `1. 회원은 다음 각 호의 행위를 하여서는 아니 됩니다.`,
  `  1-1. 이용 신청 및 서비스를 제공받기 위해 등록 양식에서 요구되는 정보를 허위 또는 타인의 명의로 작성하거나, 다른 회원의 ID 및 비밀번호를 도용, 부정하게 사용하는 행위`,
  `  1-2. 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통 시키거나 상업적으로 이용하는 행위`,
  `  1-3. 타인에게 욕설/협박 및 명예를 손상시키거나 불이익을 주는 행위`,
  `  1-4. 음란물을 게재, 공개 하거나 음란사이트를 연결(링크)하는 행위`,
  `  1-5. 회사 및 제3자의 지적재산권 등 기타 권리를 침해하는 행위`,
  `  1-6. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위`,
  `  1-7. 서비스와 관련된 설비의 오 동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 행위`,
  `  1-8. 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 의사에 반하여 광고성 정보를 전송하는 행위`,
  `  1-9. 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위`,
  `  1-10. 다른 회원의 개인정보를 수집, 저장, 공개하는 행위`,
  `  1-11. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위`,
  `  1-12. 재물을 걸고 도박을 하는 등의 사행행위`,
  `  1-13. 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위`,
  `  1-14. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위`,
  `  1-15. 서비스에 게시된 정보를 변경하는 행위`,
  `  1-16. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위`,
  `  1-17. 회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 메일을 발송하는 행위`,
  `  1-18. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 e-mail으로 발송하는 행위`,
  `  1-19. 사이트를 이용하여 구입한 재화 용역 등의 대금, 기타 사이트 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 행위`,
  `  1-20. 다른 사람의 사이트 이용을 방해하거나 그 정보를 도용하는 등 전자거래 질서를 위협하는 행위`,
  `  1-21. 회사에서 공식적으로 인정한 경우를 제외한 서비스를 이용하여 상품을 판매하는 영업 활동 및 해킹, 영리를 목적으로 하는 광고행위, 음란사이트를 통한 상업행위, 상용소프트웨어 불법배포 행위`,
  `  1-22. 법률에 의하거나 계약상 또는 위임에 의하여 전송할 수 있는 권리가 없는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로 전송하거나 공개하는 행위`,
  `  1-23. 타인을 "스톡(stalk)"하거나 달리 괴롭히는 행위 또는 다른 회원에 대한 개인정보를 수집 또는 저장하는 행위`,
  `  1-24. 기타 불법적이거나 부당한 행위`,
  `2. 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다.`,
  `3. 본 조의 위반으로 인해 발생된 회원의 관계기관에 의한 구속 등 법적 조치 등에 관해서는 회사가 책임을 지지 않으며, 회원은 이와 같은 행위와 관련하여 회사에 손해를 끼쳤을 경우 회사에 대하여 손해배상 의무를 집니다.`,
  `\n`,
  `제29조 [지적재산권]`,
  `1. 서비스에 게재되거나 공개, 제출된 모든 자료(“회원”간 전달 포함)에 대한 소유권은 회원과 회사가 별도로 정하지 않는 한 공개자 또는 게시자에게 있습니다. 단, 회사는 원활한 서비스를 위하여 게시물 관리정책 또는 『정보통신망이용촉진 및 정보보호에 관한 법률』, 『청소년 보호법』, 『저작권법』 등의 법률에 따라 일정한 기간 이후에는 공개자 또는 게시자의 동의 없이 게재된 내용을 삭제할 수 있습니다.`,
  `2. 회원이 이용계약을 해지하거나 적법한 사유로 이용계약이 해지 된 경우 회원 게시물의 권리는 회사에 귀속됩니다.`,
  `3. 회원은 관련법령의 규정에서 별도로 정하지 않는 한 서비스에 공개적으로 게재하거나 제출한 자료에 대해 회사에게 비독점적이고 재라이센스 할 수 있는 권한을 부여 하는 것으로 간주 합니다.`,
  `4. 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재된 자료를 영리목적으로 이용하거나 제3자에게 이용하게 할 수 없으며, 공개물 또는 게시물에 대한 저작권 침해는 관계 법령의 적용을 받습니다.`,
  `5. 회원은 회원이 제출한 내용으로 인하여 지적재산권 분쟁이 발생한 경우 회사 및 관계자를 면책 하고 해를 입지 않도록 할 것을 동의합니다.`,
  `6. 본 서비스 또는 서비스와 관련된 소프트웨어는 관련 지적재산권 및 기타 법률에 의해 보호되며, 후원 광고에 포함되어 있는 내용이나 본 서비스 또는 광고주를 통하여 회원에게 제공 되는 정보는 저작권, 상표권, 특허 등 제반 지적재산권 관련 법규에 의해 보호됩니다.`,
  `7. 서비스는 회원에게 한 대의 컴퓨터에서 소프트웨어의 오브젝트 코드를 사용할 수 있는 개인적이고, 양도불가능하며, 비독점적인 권리 및 사용권을 부여합니다. 단, 회원은 소프트웨어를 복사, 수정, 창작물의 제작, 리버스 엔지니어, 리버스 어셈블 또는 소스코드를 발견하려고 시도하거나, 판매, 양도, 재라이센스, 담보권을 설정하거나 소프트웨어상의 어떠한 권리를 달리 양도하여서는 안되며, 제3자로 하여금 위와 같은 행위를 하도록 허락하여서도 안됩니다.`,
  `\n`,
  `제30조 [게시물의 관리]`,
  `1. 회사는 제28조 제1항 각 호에 해당하는 게시물이나 자료를 사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수 있으며, 이에 대해 회사는 어떠한 책임도 지지 않습니다. 또한, 그 게시물의 양과 성격에 따라 서비스 사용 중지 또는 회원자격의 제한을 둘 수 있습니다.`,
  `2. 회사는 게시판에 『정보통신망이용촉진 및 정보보호에 관한 법률』을 위반한 청소년 유해 매체물이 게시되어 있는 경우에는 이를 지체 없이 삭제 합니다. 다만, 만 19세 이상의 회원만 이용할 수 있는 게시판은 예외로 합니다.`,
  `3. 회사가 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 자는 회사에게 당해 정보의 삭제 또는 반박내용의 게재를 요청할 수 있습니다. 이 경우 회사는 지체 없이 필요한 조치를 취하고 이를 즉시 신청인에게 통지합니다.`,
  `4. 회사는 게시물에 관련된 세부 이용지침을 별도로 정하여 시행할 수 있으며, 회원은 그 지침에 따라 각 종 게시물(회원간 전달 포함)을 등록하거나 삭제하여야 합니다.`,
  `5. 회원이 게시하였던 게시물은 자동 삭제 되지 않으므로 삭제를 원할 경우 탈퇴 이전에 삭제하여야 하며, 회사는 회원이 이용계약을 해지하거나 적법한 사유로 이용계약이 해지 된 경우 회원의 게시물을 삭제 또는 별도 관리 할 수 있습니다.`,
  `6. 회원의 게시물이 『정보통신망법 및 저작권법 등 관련 법령』에 위반 되는 내용을 포함할 경우, 해당 권리자는 관련 법령이 정한 절차에 의거하여 해당 게시물의 게시 중단 및 삭제 등을 회사에 요청 할 수 있으며, 회사는 관련 법령에 따른 조치를 취하여야 합니다.`,
  `\n`,
  `\n`,
  `제5장 계약해지 및 기타`,
  `\n`,
  `제31조 [유료 서비스 결제 이용에 관한 해제 및 해지]`,
  `1. 유료서비스 이용계약을 체결한 이용자는 계약체결일로부터 7일 이내에 청약을 철회하거나 해당 계약을 해제(이하 “청약철회등”)할 수 있습니다. 다만, 다음 각 호중 하나에 해당하는 경우에는 이용자의 청약철회등이 제한될 수 있습니다.`,
  `  1-1. 청약의 철회가 불가능한 서비스에 대한 사실을 표시(공지)사항에 포함한 경우`,
  `  1-2. 이용자가 회사가 판단하는 악의적인 목적으로 구매와 취소를 반복하는 경우`,
  `  1-3. 회사가 한시적 또는 일부 이용 등의 방법을 제공한 경우`,
  `\n`,
  `1-4 이용자에게 책임이 있는 사유로 재화 등이 멸실되거나 훼손된 경우`,
  `\n`,
  `1-5 복제가 가능한 재화 등의 포장을 훼손한 경우`,
  `\n`,
  `1-6 시간이 지나 다시 판매하기 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우`,
  `\n`,
  `1-7 용역 또는 콘텐츠의 제공이 개시된 경우`,
  `\n`,
  `1-8 이용자의 주문에 따라 개별적으로 생산되는 재화 등 또는 이와 유사한 재화 등에 대하여 청약철회등을 인정하는 경우 회사에게 회복할 수 없는 중대한 피해가 예상되는 경우로서 사전에 해당 거래에 대하여 별도로 그 사실을 고지하고 이용자의 서면에 의한 동의를 받은 경우`,
  `2. 이용자는 다음 각 호의 사유가 있을 때에는 당해 유료서비스를 공급받은 날로부터 7일 이내에 유료서비스 이용계약을 해지할 수 있습니다.`,
  `  1-1. 이용계약에서 약정한 서비스가 제공되지 않는 경우`,
  `  1-2. 제공되는 서비스가 표시, 광고 등과 상이하거나 현저한 차이가 있는 경우`,
  `  1-3. 기타 “콘텐츠”의 결함으로 정상적인 서비스 이용이 현저히 불가능한 경우`,
  `3. 전1항 내지 전2항의 경우에 회원은 언제든지 “고객센터”, “개인정보관리 페이지” 등을 통해서 이용계약을 해지 신청할 수 있으며 회사는 관계법령 등에서 정하는 절차에 따라 이를 신속하게 처리합니다.`,
  `4. 회사는 제3항에 따라 회원이 표시한 계약해제, 해지의 의사표시를 수신한 후 지체 없이 이러한 사실을 회원에게 회신합니다.`,
  `5. 회원은 제2항 2호의 사유로 계약해제, 해지의 의사표시를 하기 전에 상당한 기간을 정하여 서비스이용의 하자에 대한 치유를 요구할 수 있습니다. 다만, 회사가 하자의 치유가 불가능하다고 판단하는 경우에는 즉시 그 사실을 회원에게 통지하고 이용계약을 해제, 해지할 수 있습니다.`,
  `6. 회사는 회원이 제26조에 규정한 회원의 의무를 이행하지 않을 경우 사전 통지 없이 본 서비스 이용 계약을 해지하거나 또는 유료 서비스 이용을 중지 시킬 수 있습니다.`,
  `7. 회원 또는 회사가 유료 결제에 대한 이용계약을 해지할 경우 관련법령 및 개인정보취급방침에서 정하는 바에 따라 일정 기간 저장된 후 파기됩니다.`,
  `\n`,
  `제32조 [이용자의 청약철회등의 효과]`,
  `1. 회사는 회원이 청약철회의 의사표시를 한 날로부터 또는 이용자의 계약해제, 해지의 의사표시에 대하여 회신한 날로부터 10영업일 이내에 대금의 결제와 동일한 방법으로 이를 환불하여야 하며, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에 고지하여야 합니다. 결제대행사를 통한 환불의 경우 대행사의 환불규정에 따릅니다. 다만, 수납확인이나 필요한 결제수단의 경우에는 확인일로부터 10영업일 이내에 이를 환불하도록 합니다.`,
  `2. 회사가 제1항에 따라 회원이 구매한 상품을 중도 해지하여 환불할 경우, 회사는 회원이 유료서비스 이용으로부터 얻은 이익에 해당하는 금액(소비자공급원가 기준)을 공제하고 환급할 수 있습니다.`,
  `\n`,
  `\n`,
  `3. 회사는 위 대금을 환불함에 있어 회원이 신용카드 또는 전자화폐 등으로 결제를 한 때에는 지체 없이 해당 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다. 다만, 제2항의 금액공제가 필요한 경우에는 그러하지 아니할 수 있습니다.`,
  `4. 계약해제, 해지 요청에 따라 각 결제수단별로 다음 각 호의 방법에 따라 환불하며, 단, 결제수단별 취소가능 기간, 취소 방법 또는 취소 후 조치방법에 차이가 있을 수 있습니다.`,
  `  1-1. 무통장입금의 경우 은행송금수수료를 공제한 잔액을 현금으로 반환합니다.`,
  `  1-2. 휴대폰결제의 경우는 결제한 해당 월내에만 결제 취소 가능합니다.`,
  `  1-3. 각 결제 수단별로 취소 가능 기간이 지난 경우 현금 환불 시에는 환불수수료(상품의10% 와 예매수수료)를 공제한 잔액을 현금으로 반환하며, 환불 금액이 1,000원 미만인 경우와 무상으로 지급된 건은 환불되지 않습니다.`,
  `  1-4. 그 외의 결제수단은 각 결제수단별 결제취소 절차에 따릅니다.`,
  `  1-5. 회원은 회원 탈퇴시 잔여 마일리지는 탈퇴신청 전에 소진하여야 하며 회원탈퇴 후에는 자동으로 소멸되어 환불신청이 불가능합니다.`,
  `  1-6. 회원이 제11조, 제12조에 해당하는 행위를 하였을 경우, 회사가 계약을 해제 또는 해지하거나 서비스 이용을 제한 한 후 환불해야 할 금액이 있을 경우에는 본 조 제2항, 제3항에서 정한 환불 기준을 적용하여 공제하고 환불합니다. 이 경우 회원은 해당 조치에 대하여 회사가 정한 절차에 따라 이의 신청을 할 수 있으며, 회사는 정당하다고 인정하는 경우 즉시 서비스 이용 재개 등을 합니다.`,
  `  1-7. 시스템상의 장애로 인해 결제 후 유료 서비스 이용이 안되는 경우, 회사는 결제를 취소하거나 결제수단에 따라 결제취소가 불가능한 경우 이용자에게 공지하고 대금의 결제와 동일한 방법으로 환불을 하여야 합니다.`,
  `  1-8. 회사는 “콘텐츠 등의 대금을 지급 받은 자” 또는 “이용자와 콘텐츠이용계약을 체결한 자“가 동일인이 아닌 경우에 각자는 청약철회 또는 계약해제, 해지로 인한 대금환급과 관련한 의무의 이행에 있어서 연대하여 책임을 집니다.`,
  `  1-9. 회사는 회원에게 청약철회를 이유로 위약금 또는 손해배상을 청구하지 않으며, 회원의 계약 해제, 해지는 손해배상의 청구에 영향을 미치지 않습니다. 단, 이용기간을 약정한 상품에 대한 해지에 대해서는 위약금이 청구될 수 있습니다.`,
  `\n`,
  `제33조 [회사의 계약해제, 해지 및 이용제한]`,
  `1. 회사는 회원이 제12조, 제13조에서 정한 행위를 하였을 경우 사전통지 없이 계약을 해제, 해지하거나 또는 기간을 정하여 서비스 이용을 제한할 수 있습니다.`,
  `2. 제1항의 해제, 해지는 회사가 정한 통지방법에 따라 회원에게 그 의사를 표시한 때에 효력이 발생합니다.`,
  `3. 회사의 해제, 해지 및 이용제한에 대하여 회원은 회사가 정한 절차에 따라 이의 신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우, 회사는 즉시 서비스의 이용을 재개합니다. `,
  `\n`,
  `제34조 [회사의 계약해제, 해지의 효과]`,
  `회원의 귀책사유에 따른 이용계약의 해제, 해지의 효과는 회사가 정한 회원약관의 내용에 준용합니다. 다만, 회사는 이용자에 대하여 계약 해제, 해지의 의사표시를 한 날로부터 10영업일 이내에 대금의 결제와 동일한 방법으로 이를 환급합니다.`,
  `\n`,
  `제35조 [과오금]`,
  `1. 회사는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금 전액을 환불하여야 합니다. 다만, 동일한 방법으로 환불이 불가능할 때는 이를 사전에 고지합니다.`,
  `2. 회사의 책임 있는 사유로 과오금이 발생한 경우 회사는 계약비용, 수수료 등에 관계없이 과오금 전액을 환불합니다. 다만, 이용자의 책임 있는 사유로 과오금이 발생한 경우, 회사가 과오금을 환불하는 데 소요되는 비용은 합리적인 범위 내에서 이용자가 부담하여야 합니다.`,
  `3. 이용자의 월정액 결제 이용 대금이 적게 과금 된 경우 회사는 이용자와의 상호 합의하에 차액을 요구할 수 있습니다.`,
  `4. 회사는 이용자가 주장하는 과오금에 대해 환불을 거부할 경우에 정당하게 이용대금이 부과되었음을 입증할 책임을 집니다.`,
  `5. 회사는 과오금의 환불절차를 『디지털콘텐츠 이용자보호지침』에 따라 처리합니다.`,
  `\n`,
  `제36조 [콘텐츠하자 등에 의한 이용자피해보상]`,
  `회사는 콘텐츠하자 등에 의한 이용자피해보상의 기준,범위,방법 및 절차에 관한 사항을 『디지털콘텐츠 이용자보호지침』에 따라 처리합니다.`,
  `\n`,
  `제37조 [보증의 부인]`,
  `1. 본 서비스를 이용하여 어떠한 자료를 다운로드 또는 스트리밍하는 행위는 회원의 판단 및 위험에 의해 행하여지고, 그러한 자료와 다운로드로 인해 초래되는 컴퓨터 시스템에 대한 손해 및 데이터 손실에 대해서는 회원이 전적으로 책임을 부담합니다.`,
  `2. 회원이 본 서비스를 통하여 취득한 구두 또는 문서상의 모든 충고와 정보에 대하여서는 본 약관에 명시적으로 규정되어 있지 않은 어떠한 보증도 제공되지 않습니다.`,
  `\n`,
  `제38조 [양도 금지]`,
  `회원은 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여할 수 없으며 게시물 등 모든 형태의 공개자료에 대한 저작권을 포함한 모든 권리 및 책임은 이를 공개한 회원에게 있습니다.`,
  `\n`,
  `\n`,
  `제6장 손해배상 등`,
  `\n`,
  `제39조 [손해배상]`,
  `1. 본 서비스는 회원의 편의를 위하여 제공하는 서비스로, 본 서비스와 관련된 부과금액 등 이용요금이 무료인 동안에는 본 서비스 이용과 관련하여 발생한 어떠한 손해에 대하여도 회사가 책임을 지지 않습니다.`,
  `2. 회원이 본 약관을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.`,
  `3. 회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 “회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책 시켜야 하며, 회사가 면책되지 못한 경우 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다.`,
  `4. 회사 제공 서비스 및 유료 결제 서비스등의 제공과 관련하여 회사의 귀책사유로 인하여 회원이 서비스 이용에 손해를 입은 경우, 회원은 회사 제공 서비스 복구 등 합당하고 적절한 보상을 받을 수 있습니다.`,
  `\n`,
  `제40조 [면책사항]`,
  `1. 회사는 다음 각 호의 1에 해당하는 사유로 인하여 회원 또는 제3자에게 발생한 손해에 대하여는 그 책임을 지지 아니합니다.`,
  `  1-1. 천재지변 또는 이에 준하는 불가항력으로 인해 서비스를 제공할 수 없는 경우`,
  `  1-2. 회원이 자신의 ID 또는 비밀번호 등의 관리를 소홀히 하는 등 타인의 부정사용을 방치한 경우`,
  `  1-3. 회원이 제3자의 ID, 비밀번호, 휴대폰, 계좌, 신용카드 번호 등 개인정보를 도용하여 제3자에게 손해를 발생시킨 경우`,
  `  1-4. 회사의 관리 영역이 아닌 공중통신선로의 장애로 서비스 이용이 불가능한 경우`,
  `  1-5. 기타 회사의 귀책 사유가 없는 통신서비스 등의 장애로 인한 경우`,
  `2. 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며 그 밖에 서비스를 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.`,
  `3. 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다.`,
  `4. 회사는 서비스 이용과 관련하여 회원에게 발생한 손해 가운데 회원의 고의, 과실에 의한 손해에 대하여 책임을 지지 않습니다.`,
  `5. 회사는 회원 상호간 또는 회원과 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.`,
  `\n`,
  `제41조 [관할법원]`,
  `1. 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 쌍방간에 분쟁의 해결을 위해 성실히 협의한 후가 아니면 제소할 수 없습니다.`,
  `2. 본 조 제1항의 협의에서도 분쟁이 해결되지 않을 경우 회사와 회원간의 콘텐츠 이용계약에 관한 『민사소송법』상의 관할법원에 소를 제기할 수 있습니다.`,
  `\n`,
  `부칙 (시행일)`,
  `본 약관은 2024년 3월 12일부터 적용합니다.`,
]

export const serviceLog20250103 = [
  `제1장 총칙`,
  `\n`,
  `제 1조 [목적]`,
  `이 약관은 주식회사 케이티스포츠(이하 “회사”라 합니다)와 이용고객(이하 “회원”이라고 함)간에 회사가 제공하는 콘텐츠 서비스인 wizzap 서비스(이하 “서비스”라 합니다) 및 제반 서비스를 유선 또는 무선 인터넷 등의 수단으로 이용함에 있어 회사와 회원간의 권리, 이용에 관한 제반 사항과 기타 필요한 사항을 규정하는 것을 목적으로 합니다.`,
  `\n`,
  `제2조 [용어의 정의]`,
  `이 약관에서 사용하는 용어의 정의는 다음 각호와 같습니다.`,
  `1. “이용자”라 함은 회사가 제공하는 서비스에 유선 또는 무선 인터넷 등의 수단으로 접속하여 이 약관에 따라 회사가 제공하는 콘텐츠 및 제반 서비스를 이용하는 간편회원 및 실명회원을 말하며 아래 “회원”의 개념을 포함합니다.`,
  `2. “회원”이라 함은 회사와 서비스 이용계약을 체결하고 아이디(ID)를 부여 받은 이용자로서 회사의 정보를 지속적으로 제공받으며 회사가 제공하는 서비스를 지속적으로 이용할 수 있는 자를 말합니다.`,
  `3. 간편회원이라 함은 실명인증 절차 없이 이메일 인증 등을 통해 가입한 회원으로, 실명인증이 필요한 서비스(유료회원권 등)를 제외한 일부 서비스 기능만을 제한적으로 이용할 수 있는 자를 말합니다.`,
  `4. 실명회원이라 함은 본인인증 절차를 거쳐 실명으로 가입한 회원으로 회사가 제공하는 유/무료 서비스를 지속적으로 이용 가능한 자를 말합니다.`,
  `5. “아이디(ID)”라 함은 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 영문자와 숫자의 조합을 의미합니다.`,
  `6. “비밀번호(Password)”라 함은 회원이 부여 받은 아이디(ID)와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합 또는 생체인식정보 등을 말합니다.`,
  `7. “콘텐츠”라 함은 부호, 문자, 음성, 음향, 이미지 및 영상 등(이들의 복합체를 포함합니다)으로 표현된 자료 또는 정보로서, 그 보존 및 이용에 있어서 효용을 높일 수 있도록 디지털 형태로 제작하거나 처리한 것을 말합니다.`,
  `8. “유료 회원권”이라 함은 전2항의 회원이 일정 금액을 회사에 지불하고 이용할 수 있는 콘텐츠 서비스 또는 상품을 의미합니다.`,
  `9. 본 조 제1항에서 정의된 용어 이외의 용어에 대해서는 관계 법령 및 서비스 별 이용기준에서 정의하는 바에 따릅니다.`,
  `\n`,
  `제3조 [신원정보 등의 제공]`,
  `회사는 이 약관의 내용, 상호, 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호, 모사전송번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호 및 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 온라인 서비스화면에 게시합니다. 다만, 약관은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.`,
  `\n`,
  `제4조 [약관의 게시 등]`,
  `1. 회사는 이 약관을 회원이 그 전부를 인쇄할 수 있고 거래과정에서 해당 약관의 내용을 확인할 수 있도록 기술 조치를 취합니다.`,
  `2. 회사는 이용자가 회사와 이 약관의 내용에 관하여 질의 및 응답할 수 있도록 기술적 장치를 설치합니다.`,
  `3. 회사는 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회, 환불조건 등과 같은 중요한 내용을 이용자가 쉽게 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구합니다.`,
  `\n`,
  `제5조 [약관의 효력 및 변경]`,
  `1. 본 약관의 내용은 회원가입 시 게재되거나 공지된 내용에 회원이 동의함으로써 그 효력이 발생합니다.`,
  `2. 회사는 『콘텐츠산업진흥법』, 『전자상거래 등에서의 소비자보호에 관한 법률』,  『약관의 규제에 관한 법률』 등 관련법령을 위반하지 않는 범위에서 이 약관을 변경할 수 있습니다.`,
  `3. 제2항에 따라 약관을 변경할 경우, 회사는 시행일 및 변경사유를 명시하여 개정약관을 서비스 초기화면에서 다음 각 호에서 정하는 기간 및 시행일로부터 상당한 기간 동안 공지합니다. 다만, 정당한 사유가 있는 경우, 개정약관 등을 확인할 수 있는 링크 등을 제공할 수 있습니다.`,
  `   1. 변경하고자 하는 약관의 내용이 중대하거나 회원에게 불리한 경우: 시행일로부터 30일 전부터 시행일까지`,
  `   2. 제1호에 해당하지 않는 경우: 시행일로부터 7일 전부터 시행일까지 `,
  `4. 제2항에 따라 약관을 변경할 경우에 회사는 회원에게 다음 각 호에서 정하는 기한까지 변경 약관 및 변경사유를 전자우편주소로 전송하고, 동의를 받습니다. `,
  `   1. 변경하고자 하는 약관의 내용이 중대하거나 회원에게 불리한 경우: 시행일로부터 30일 전까지 `,
  `   2. 제1호에 해당하지 않는 경우: 시행일로부터 7일 전까지 `,
  `5. 회원은 개정된 약관에 대해 동의하지 않을 권리가 있으며, 개정된 약관에 동의하지 않을 경우 이용계약을 해지할 수 있습니다. 회사가 제4항에 따라 고지하면서 『이 기한 내에 변경 약관의 적용에 대해 거절의 의사를 표시하지 않으면 동의한 것으로 간주합니다』라는 사실을 명확히 표시한 경우에 그 기한까지 거절의 의사를 표시하지 않거나 이용계약을 해지하지 않은 경우 변경된 약관을 승인한 것으로 봅니다.`,
  `\n`,
  `제6조 [약관의 해석 및 약관 외 사항에 대한 규정]`,
  `1. 회사는 이 약관 외에 별도의 이용약관 및 정책(이하 “개별약관등”)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 개별약관등이 우선하여 적용됩니다. `,
  `2. 이 약관에서 정하지 않은 사항이나 해석에 대해서는 개별약관등 및 관계 법령 또는 상관례에 따릅니다. `,
  `\n`,
  `\n`,
  `제2장 서비스 이용 계약`,
  `\n`,
  `7조 [이용신청, 승낙 및 거절, 계약의 성립]`,
  `1. 회원이 되고자 희망하는 이용자는 약관의 내용에 대하여 동의를 하고 회원가입신청을 한 후 회사가 이러한 신청에 대하여 승낙함으로써 이용계약이 체결됩니다.`,
  `2. 이용신청자는 본 약관 동의와 함께 회사가 필요로 하는 정보를 정확히 작성하여 제출하고 회사는 이를 심사한 후 승낙함으로써 이용계약이 성립됩니다.`,
  `3. 회사는 다음 각호의 어느 하나에 해당하는 사유가 있는 경우 회원가입신청에 대하여 거절할 수 있습니다.`,
  `  1-1. 이용신청에 필요한 사항을 정확하게 기재하지 않은 경우`,
  `  1-2. 실명이 아니거나 타인의 명의를 이용한 경우(실명회원 가입의 경우)`,
  `  1-3. 이용자 등록 사항을 누락하거나 오기하여 신청하는 경우`,
  `  1-4. 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우`,
  `  1-5. 회원자격을 상실한 자로서 회사가 정한 일정 가입보류 기간이 경과되지 아니한 자`,
  `  1-6. 14세 미만의 자가 법정대리인의 동의를 얻지 않은 경우`,
  `  1-7. 기술 및 설비의 미보유로 인하여 서비스 제공이 가능하지 않은 경우`,
  `  1-8. 기타 이용신청자의 귀책에 의하여 승낙이 불가능하거나, 회사가 별도로 정한 이용신청 기준에 부합되지 아니한 자`,
  `4. 회사는 서비스 관련 설비의 여유가 없거나 기술상 또는 업무상 문제가 있는 경우에는 가입신청의 승낙을 유보하거나 거절할 수 있습니다.`,
  `5. 제3항 또는 제4항에 따라 회원가입 신청에 대하여 유보하거나 거절한 경우 회사는 이를 신청자에게 즉시 알려야 합니다. 다만, 회사가 고의 또는 과실 없이 신청자에게 통지할 수 없는 경우에는 그러하지 않습니다.`,
  `\n`,
  `제8조 [미성년자의 회원가입에 관한 특칙]`,
  `1. 만 14세 미만의 이용자는 개인정보의 수집 및 이용목적에 대하여 충분히 숙지하고 부모 등 법정대리인의 동의를 얻은 후에 회원가입을 신청하고 본인의 개인정보를 제공하여야 합니다.`,
  `2. 회사는 부모 등 법정대리인의 동의에 대한 확인절차를 거치지 않은 만 14세 미만 이용자의 이용신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.  `,
  `3. 만 14세 미만 이용자의 부모 등 법정대리인은 아동에 대한 개인정보의 열람, 정정, 갱신을 요청하거나 회원가입에 대한 동의를 철회할 수 있으며, 이러한 경우에 회사는 지체 없이 필요한 조치를 취해야 합니다.`,
  `\n`,
  `제9조 [회원 정보의 수정 및 관리]`,
  `1. 회원은 회원정보확인화면을 통해서 언제든지 개인정보를 열람하고 수정할 수 있으며, 이때 서비스 관리를 위해 필요한 실명 등은 수정이 불가합니다. 개명의 경우 실명 재인증을 통해 변경 가능합니다.`,
  `2. 회원은 수시로 회원가입 신청 시 기재한 사항에 대하여 변경이 되었을 경우, 온라인에서 수정하거나 고객센터 연락 등의 방법으로 회사에 그 사실을 알려야 합니다.`,
  `3. 회사는 제2항에 따라 회원으로부터 변경사항을 통지 받은 경우 지체 없이 이에 따라 개인정보를 변경합니다.`,
  `4. 회사가 제3항에 따라 변경하지 않음으로 인하여 발생한 회원의 손해에 대하여 배상합니다. 다만, 회사가 고의 또는 과실이 없음을 증명한 경우에는 그러하지 않습니다.`,
  `5. 회사는 회원이 제2항에 따라 수정하지 않거나 이의 변경사항을 회사에 알리자 않아 발생한 불이익에 대하여 책임을 지지 않습니다.`,
  `\n`,
  `제10조(아이디 및 비밀번호 관리의무 등)`,
  `1. 회원은 자신의 아이디와 비밀번호를 선량한 관리자의 주의의무로 관리하며 제3자에게 이용허락 할 수 없습니다. 다만, 회사가 동의한 경우에는 그러하지 않습니다.`,
  `2. 회원이 제1항 본문을 위반한 경우에 회사는 회원에게 발생한 손해에 대해 책임을 지지 않습니다. `,
  `3. 회원은 아이디 및 비밀번호가 도용되거나 제3자에 의해 사용되고 있음을 알게 된 경우에 즉시 회사에게 그 사실을 통지하고, 회사의 안내에 따라야 합니다. `,
  `4. 제3항의 경우, 회원이 회사에게 그 사실을 통지하지 않거나 통지한 경우에도 회사의 안내에 따르지 않아 발생한 회원의 손해에 대해 회사는 책임을 지지 않습니다. `,
  `5. 회원은 도용 등을 방지하기 위해 주기적으로 비밀번호를 변경하며, 회사는 회원에게 비밀번호의 변경을 권고할 수 있습니다. `,
  `6. 회사는 회원의 아이디가 개인정보유출 우려가 있거나, 반사회적 행위 및 미풍양속을 저해하거나 회사 및 회사의 운영자로 오인하게 할 수 있도록 사용되는 경우, 아이디의 이용을 제한 할 수 있습니다.`,
  `\n`,
  `제11조 [회원에 대한 통지]`,
  `1. 회사는 별도의 방법을 정하지 않는 한 회원에 대한 통지는 회원이 지정한 전자우편 또는 휴대폰 메세지의 방법에 의합니다.`,
  `\n`,
  `제12조 [회원자격 정지]`,
  `1. 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원의 자격을 제한하거나 정지시킬 수 있습니다. 이 경우 회사는 회원에게 해당 사유를 통지합니다.`,
  `  1-1. 다른 사람이 회사의 서비스를 이용하는 것을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우 `,
  `  1-2. 회사가 금지한 정보(컴퓨터 프로그램 등)의 사용, 송신 또는 게시`,
  `  1-3. 회사 또는 제3자의 저작권 등 지식 재산권에 대한 침해.`,
  `  1-4. 회사 또는 제3자에게의 욕설 및 협박, 명예훼손 및 영업, 서비스이용을 방해하는 행위.`,
  `  1-5. 회사를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우`,
  `  1-6. 회사의 기술적 보호조치를 회피 혹은 무력화 하는 행위.`,
  `  1-7. 회사가 제공하는 서비스를 정상적인 용도 이외 또는 부당한 방법으로 서비스를 이용/악용한 이력이 명백한 경우`,
  `  1-8. 제28조 1항 각호에 해당하는 사항을 위반하였을 경우`,
  `  1-9. 회원이 유료 회원권을 이용하여 자신이 이용할 목적과 의사 없이 입장권을 예매하여 이를 외부 사이트 등에서 재판매하거나 경기 시작 직전에 취소함으로써 회사에 손해를 끼치는 행위.`,
  `2. 회사가 회원의 자격을 제한 및 정지하는 경우 회원에게 이를그 사유를 명시하여 통지합니다. 회원은 통지일로부터 7일 이내에 자신의 행위가 정당한 것임을 소명할 수 있고, 그 내용이 정당한 경우 회사는 즉시 회원의 자격을 복구합니다. 단, 회사가 정한 소명기간 동안 소명치 않은 경우 회원은 회원 자격의 정지에 동의한 것으로 간주합니다.`,
  `  2-1. 회원 자격 제한 유형은 (i) 자격 정지, (ii) 제13조의 자격상실(회원탈퇴)로 구분하며, 회사는 회원에게 위 1항의 행위 최초 발생 시 (i) 3개월간 자격 정지를, 해당 행위 2회 및 30일 이내 위반 사유가 시정되지 않는 경우 6개월간 자격 정지를, 3회 이상 반복 시 1년간 자격 정지를 통지할 수 있습니다.`,
  `  2-2. 회원 자격 정지기간은 최대 1년으로 합니다. `,
  `\n`,
  `제13조 [회원탈퇴]`,
  `1. 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원의 탈퇴를 처리합니다.`,
  `2. 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원을 탈퇴시킬 수 있습니다. 이 경우 회사는 회원에게 해당 사유를 통지합니다.`,
  ` 2-1. 제12조 1항의 사유에 해당하여 회사가 회원의 자격을 제한 및 정지 시킨 후, 동일한 행위가 1회 이상 재발하는 경우 `,
  ` 2-2. 회원이 구단 서비스를 이용 시 본인 및 동반인의 연령, 회원등급, 티켓 구매 내역 등을 회사에 허위로 제공하고 이로 인해 회원 본인 및 동반인이 금전적/서비스적 이득을 취하거나, 타인에게 불이익을 준 내용이 적발될 경우`,
  ` 2-3. 회원이 구단 서비스를 이용하며 회사 또는 제3자에게의 욕설 및 협박, 명예훼손 및 영업, 서비스이용의 방해가 2회 이상 반복되는 경우`,
  `3. 회사가 회원을 탈퇴하는 경우 회원 등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 통지일 기준 최소 7일의 기간을 정하여 소명하고, 그 내용이 정당한 경우 회사는 즉시 회원의 자격을 복구합니다. 단, 회사가 정한 소명기간 동안 소명치 않은 경우 탈퇴 동의로 간주합니다.`,
  `4. 회원의 탈퇴일 기준 1개월간 재가입이 불가하며, 재가입이 진행될 경우 회원 가입 시 첫회 제공되는 혜택의 대상에서 제외됩니다.`,
  `5. 본조 2항에 따른 탈퇴가 반복되는 경우, 회사는 회원의 계정을 중지하거나 해지할 수 있으며, 현재 또는 장래의 모든 또는 일부의 서비스 이용을 거절 할 수 있습니다. 이로 인한 책임은 모두 회원 본인에게 있습니다.`,
  `6. 회사는 회원이 탈퇴하거나 회원자격을 상실하는 경우 회원의 개인정보를 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 등 관계법령에서 정한 범위와 절차에 따라 파기합니다.`,
  `\n`,
  `제14조 [개인정보의 보호]`,
  `회사는 관련법령이 정하는 바에 따라서 회원” 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관해서는 관련법령 및 회사가 정하는 개인정보취급방침에 정한 바에 따릅니다. 다만, 회사의 사이트 이외에 단순 링크사이트, 제휴된 몰의 사이트 등의 경우에는 개인정보취급방침이 적용되지 아니합니다.`,
  `\n`,
  `\n`,
  `제3장 서비스 이용`,
  `\n`,
  `제15조 [서비스의 이용개시]`,
  `  1. 회사는 회원의 이용 신청을 승낙한 때부터 서비스를 개시합니다. 단, 유료 회원권 및 월정액 등 유료 서비스의 경우 회사가 지정하는 수단으로 결제가 완료된 후 이용 가능합니다.`,
  `  2. 회사의 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 사이트에 공지하거나 회원에게 이를 통지합니다.`,
  `\n`,
  `제16조 [서비스의 중단 및 변경]`,
  `회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 서비스의 전부 또는 일부를 변경할 수 있고, 해당 서비스 초기화면에 관련 사항을 게시합니다. 다만, 유료서비스를 변경하는 경우로서 변경된 내용이 중대하거나 회원에게 불리한 경우에는 이 약관에서 정한 법으로 통지하고, 필요한 경우 이 약관에서 정한 바에 따라 회원에게 보상합니다.  `,
  `   `,
  `제17조 [유료 회원권의 이용]`,
  `  1. 회원이 본 약관에 동의한다는 의사표시로써 동의함을 선택함과 함께 회사에 대하여 결제를 통한 이용 신청을 하고 회사가 이를 승낙함으로써 유료 회원권 서비스(이하 “유료회원권”이라 함)에 대한 이용계약이 성립됩니다.`,
  `  2. 회원은 회사가 지정하는 결제수단으로 유료 회원권 결제를 할 수 있습니다. 단, 각종 프로모션이나 이벤트 등을 통하여 발행된 쿠폰을 유료 회원권 결제에 이용할 수 없습니다.`,
  `  3. 실명인증을 완료한 회원이 회사가 지정하는 결제수단으로 유료 회원권을 결제 및 신청 한 경우에만 “유료 회원” 자격이 부여되며, 간편회원(비실명 회원)은 유료 회원권의 결제 및 이용을 할 수 없습니다.`,
  `  4. 회사는 유료 회원권을 이용하고자 하는 회원의 구매(결제)횟수에 대하여 내부정책 및 외부 결제업체(은행사, 카드사 등), 기타 관련 법령의 변경에 따라 회원 당 구매횟수 등의 거래한도를 정할 수 있으며, 회원은 회사가 정한 구매횟수를 초과하는 범위의 결제를 할 수 없습니다.`,
  `  5. 회원이 유료 회원권을 결제함으로 인하여 회사로부터 제공된 무상 혜택은 회사의 정책에 따라 일정 기간 경과 후 자동으로 소멸될 수 있습니다.`,
  `  6. 제공되는 서비스 중 상품이나 온라인 콘텐츠의 경우에는 각 판권소유자의 이용허락 여부에 따라 제공되는 시기가 각각 달라질 수 있습니다.`,
  `  7. 무선 콘텐츠 스트리밍 또는 정보 이용시의 데이터량에 따른 요금은 회사가 별도로 청구하지 않으며, 가입하신 이동통신사가 청구합니다.`,
  `\n`,
  `제18조 [결제수단 등]`,
  `1. 회원이 결제를 위하여 이용할 수 있는 지불수단은 다음 각 호와 같습니다.`,
  `  가. 선불카드, 직불카드, 신용카드 등의 각종 카드결제`,
  `  나. 전화 또는 휴대전화 요금합산을 이용한 결제`,
  `  다. 폰 뱅킹, 인터넷 뱅킹, 메일 뱅킹 등의 각종 계좌이체`,
  `  라. 회사와 계약을 맺었거나 회사가 인정한 상품권 또는 회사에서 발행한 쿠폰 교환에 의한 결제`,
  `  마. 기타 전자적 지급방법에 의한 대금지급 등`,
  `2. 회원이 특정 결제 수단을 선택하여 결제하는 경우 개별 결제 수단을 제공하는 각각의 서비스를 통해 결제할 수 있는 한도도 각 서비스 제공사가 정하는 기준에 따르게 됩니다.`,
  `3. 회사의 사정에 따라 특정 결제수단이 추가 되거나 서비스 제공이 중단될 수 있습니다.`,
  `\n`,
  `제19조 [서비스 이용에 따른 무상혜택 및 유효기간]`,
  `1. 회사는 회원이 서비스 이용에 대한 보답으로 무료티켓 제공, 이벤트 참가 기회 제공 또는 결제액의 비율에 따른 마일리지 적립 등의 무상혜택(이하 “무상혜택등”이라 함)을 제공할 수 있습니다. `,
  `2. 회사는 회원의 무상혜택등에 대한  금융이자 지급 의무가 없습니다.`,
  `3. 회원은 무상혜택등을 회사가 지정한 서비스 이용 대가의 지불수단으로 사용할 수 있습니다.`,
  `4. 무상혜택등의 제공은 당해년도 1월1일부터 가능하며, 당해년도 12월31일 자동 소멸됩니다.`,
  `5. 이벤트성 무상혜택의 경우는 회사의 정책에 따라 일정 기간이 경과하면 자동으로 소멸될 수 있습니다.`,
  `6. 회원은 무상혜택등을 제3자가 사용하도록 하여서는 안되고, 회사가 허락하지 않은 방법으로 타인에게 양도하거나 타인으로부터 양도 받을 수 없습니다.`,
  `7. 회원이 무상혜택등을 제3자에게 유료로 판매하거나 무단 양도하여 금전 및 기타 재산상의 이익을 취할 경우 서비스이용약관 제11조, 제12조에 근거하여 회원탈퇴처리될 수 있으며 관계법령에 근거한 손해배상청구 및 형사처벌의 대상이 될 수 있습니다.`,
  `\n`,
  `제20조 [유료회원권 서비스 이용계약의 성립 및 승낙의 제한]`,
  `1. “회원”은 본 약관에 동의한다는 의사표시(동의함을 선택)와 함께 “회사”에 대하여 결제를 통한 이용 신청을 하고 “회사”가 이를 승낙함으로써 유료회원권 서비스에 대한 이용계약이 성립합니다.`,
  `2. “회사”는 계약 체결 전에 다음 각 호의 사항에 관하여 “회원”이 정확하게 이해하고 실수 또는 착오 없이 거래할 수 있도록 정보를 제공합니다.`,
  `  가. 해당 유료회원권 서비스 결제의 내용, 가격, 이용기간, 이용방법, 청약철회 및 해지 조건 및 그 방법, 환불에 관한 사항 및 유료서비스의 선택과 관련한 사항`,
  `  나. “콘텐츠”의 이용신청에 관한 확인 또는 “회사”의 확인에 대한 동의`,
  `  다. 결제방법의 선택`,
  `3. “회사”는 “회원”의 이용신청이 다음 각 호에 해당하는 경우에는 승낙하지 않거나 승낙을 유보할 수 있습니다.`,
  `  가. 실명이 아니거나 타인의 명의를 이용한 경우`,
  `  나. 허위의 정보를 기재하거나, “회사”가 제시하는 필수 내용을 기재하지 않은 경우`,
  `  다. 미성년자가 청소년보호법에 의해서 이용이 금지되는 “콘텐츠”를 이용하고자 하는 경우`,
  `  라. 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우`,
  `4. “회사”의 승낙의 의사표시에는 “이용자”의 이용신청에 대한 확인 및 서비스제공 가능여부, 이용신청의 정정, 취소 등에 관한 정보 등을 포함합니다`,
  `\n`,
  `제21조 [미성년회원의 유료서비스 이용계약에 관한 특칙]`,
  `회사는 만 19세 미만의 미성년회원이 유료 서비스를 이용하고자 하는 경우에 부모 등 법정 대리인의 동의를 얻거나, 계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약체결 전에 고지하는 조치를 취합니다. `,
  `\n`,
  `제22조 [수신확인통지, 이용신청 변경 및 취소]`,
  `1. 회사는 회원의 유료 서비스 결제 이용신청이 있는 경우 회원에게 수신확인통지를 합니다.`,
  `2. 수신확인통지를 받은 회원은 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 이용신청 변경 및 취소를 요청할 수 있고, 회사는 서비스제공 전에 회원의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 청약철회 등에 관한 회사의 규정에 따릅니다.`,
  `\n`,
  `제23조 [서비스의 이용시간]`,
  `1. 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 회사의 업무상이나 기술상의 이유로 서비스가 일시 중지될 수 있고, 또한 운영상의 목적으로 회사가 정한 기간에는 서비스가 일시 중지될 수 있습니다. 이러한 경우 회사는 사전에 공지함이 원칙이나 불가피한 경우 사후에 공지할 수 있습니다.`,
  `2. 유료 서비스의 경우 서비스를 신청한 시점 또는 서비스별 별도 시작시점부터 이용이 가능합니다.`,
  `3. 회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있거나 서비스별 이용 가능시간을 회사의 정책으로 정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다. `,
  `\n`,
  `제24조 [서비스의 변경 및 중지]`,
  `1. 회사는 서비스에 대하여 보다 나은 서비스를 제공하기 위한 목적 또는 운영상, 기술상 불가피한 사유가 발생된 때에는 제공중인 서비스를 본 약관의 사항의 범주 내에서 전부 또는 일부 변경할 수 있으며, 변경될 서비스의 내용 및 시행일자를 일정기간 초기화면에 공개하도록 합니다.`,
  `2. 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있으며, 그 내용을 사전에 회원에게 고지하거나, 사전 고지가 어려운 사항일 경우 사후에 고지할 수 있습니다.`,
  `  가. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우`,
  `  나. 정기점검 등의 콘텐츠 서비스의 제공에 필요한 경우`,
  `  다. 서비스 업그레이드 및 사이트 유지보수 등을 위해 필요한 경우`,
  `  라. 회원이 회사의 영업활동을 방해하는 경우`,
  `  마. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우`,
  `  바. 영상, 기록 등 각종 컨텐츠 등의 원 저작권자와의 계약 종료 등 서비스 제공을 위한 원천 데이터 확보가 어려운 경우`,
  `  사. 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우`,
  `\n`,
  `제25조 [서비스의 이용 및 저장]`,
  `1. 회사는 서비스의 이용에 관하여 본 약관 외에 게시물 등의 관리정책을 별도로 둘 수 있으며, 이를 통해 게시물 또는 기타 게재된 내용이 서비스에 의해 보유되는 최대 일수 및 용량, “서비스” 서버에 할당되는 최대 디스크 공간 및 정해진 기간 동안 서비스에 접속할 수 있는 최대한의 수 (최대 기간) 등을 관리할 수 있습니다.`,
  `2. 회사의 정책에도 불구하고 회사의 귀책사유 없이 전 제1항의 정책에 따라 서비스에 보관되는 게시물 또는 기타 게재된 내용 등을 삭제하거나 저장하지 못한데 대해 회사는 아무런 책임을 지지 않습니다.`,
  `3. 회사는 본 이용약관에 따른 서비스의 제공지역을 대한민국으로 한정할 수 있으며, 회원 또는 이용자가 유무선 인터넷을 이용하여 접속 가능한 지역은 대한민국 영토 내로 제한 받을 수 있습니다.`,
  `\n`,
  `제26조 [정보 및 광고의 제공]`,
  `1. 회사는 회원의 서비스 이용과 관련하여 필요한 정보를 서비스 홈페이지에 게재하거나 우편물, e-mail 및 휴대폰 문자메시지 등을 통해 제공할 수 있습니다. 단, 회원이 정보제공을 원치 않는다는 의사를 밝히는 경우 정보제공대상에서 해당 회원을 제외하며, 정보제공 대상에서 제외되어 정보를 제공받지 못해 불이익이 발생할 경우에는 회사는 이에 대한 책임을 지지 않습니다.`,
  `2. 이때 회사는 정보와 함께 특정 광고를 게재할 수 있으며, 광고 수신을 원하지 않을 경우 수신거부를 할 수 있습니다. 그러나 회원이 광고를 통한 제3의 서비스를 이용하는 것과 관련하여 발생하는 모든 문제에 대해서 회사는 어떠한 책임도 지지 않습니다.`,
  `\n`,
  `\n`,
  `제4장 계약당사자의 의무`,
  `\n`,
  `제27조 [회사의 의무]`,
  `1. 회사는 회원의 개인정보를 보호하고 보안시스템을 구비하여 회원이 안전하게 서비스를 이용할 수 있도록 제반 환경을 제공합니다.`,
  `2. 회사는 제 ①항의 범위 내에서 업무와 관련하여 회원의 사전 동의 없이 회원전체 또는 일부의 개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있고, 이를 위하여 회원의 컴퓨터에 쿠키를 전송할 수 있습니다. 이 경우 회원은 쿠키의 수신을 거부하거나 쿠키의 수신에 대하여 경고하도록 사용하는 컴퓨터의 브라우저의 설정을 변경할 수 있습니다.`,
  `3. 회사는 서비스와 관련한 회원의 불만사항이 접수되는 경우 이를 신속하게 처리하여야 하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 서비스 화면에 게재하거나 전자우편 등을 통하여 동 회원에게 통지합니다.`,
  `4. 회사는 『정보통신망 이용촉진 및 정보보호에 관한 법률』, 『통신비밀보호법』, 『전기통신사업법』 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.`,
  `\n`,
  `제28조 [회원의 의무]`,
  `1. 회원은 다음 각 호의 행위를 하여서는 아니 됩니다.`,
  `  1-1. 이용 신청 및 서비스를 제공받기 위해 등록 양식에서 요구되는 정보를 허위 또는 타인의 명의로 작성하거나, 다른 회원의 ID 및 비밀번호를 도용, 부정하게 사용하는 행위`,
  `  1-2. 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통 시키거나 상업적으로 이용하는 행위`,
  `  1-3. 타인에게 욕설/협박 및 명예를 손상시키거나 불이익을 주는 행위`,
  `  1-4. 음란물을 게재, 공개 하거나 음란사이트를 연결(링크)하는 행위`,
  `  1-5. 회사 및 제3자의 지적재산권 등 기타 권리를 침해하는 행위`,
  `  1-6. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위`,
  `  1-7. 서비스와 관련된 설비의 오 동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 행위`,
  `  1-8. 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 의사에 반하여 광고성 정보를 전송하는 행위`,
  `  1-9. 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위`,
  `  1-10. 다른 회원의 개인정보를 수집, 저장, 공개하는 행위`,
  `  1-11. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위`,
  `  1-12. 재물을 걸고 도박을 하는 등의 사행행위`,
  `  1-13. 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위`,
  `  1-14. 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위`,
  `  1-15. 서비스에 게시된 정보를 변경하는 행위`,
  `  1-16. 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위`,
  `  1-17. 회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 메일을 발송하는 행위`,
  `  1-18. 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 e-mail으로 발송하는 행위`,
  `  1-19. 사이트를 이용하여 구입한 재화 용역 등의 대금, 기타 사이트 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 행위`,
  `  1-20. 다른 사람의 사이트 이용을 방해하거나 그 정보를 도용하는 등 전자거래 질서를 위협하는 행위`,
  `  1-21. 회사에서 공식적으로 인정한 경우를 제외한 서비스를 이용하여 상품을 판매하는 영업 활동 및 해킹, 영리를 목적으로 하는 광고행위, 음란사이트를 통한 상업행위, 상용소프트웨어 불법배포 행위`,
  `  1-22. 법률에 의하거나 계약상 또는 위임에 의하여 전송할 수 있는 권리가 없는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로 전송하거나 공개하는 행위`,
  `  1-23. 타인을 "스톡(stalk)"하거나 달리 괴롭히는 행위 또는 다른 회원에 대한 개인정보를 수집 또는 저장하는 행위`,
  `  1-24. 기타 불법적이거나 부당한 행위`,
  ` 2. 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다.`,
  `\n`,
  `3. 회원이 본조를 위반함으로 인해 발생한 관계기관의 구속, 형사 및 행정 조치 법원 판결 등 모든 법적 조치에 대해서 회사는 어떠한 책임도 부담하지 않으며,이에 따른 모든 법적 책임은 회원에게 귀속됩니다. 또한 회원은 이러한 위반 행위로 인해 회사에 직∙간접적으로 발생한 모든 손해에 대해 손해배상 책임을 지며, 회사는 환불 시의 공제 상당액과 무관하게 회사에 발생한 손해 전액에 대한 배상을 청구할 수 있습니다.`,
  `\n`,
  `제29조 [지적재산권]`,
  `1. 서비스에 게재되거나 공개, 제출된 모든 자료(“회원”간 전달 포함)에 대한 소유권은 회원과 회사가 별도로 정하지 않는 한 공개자 또는 게시자에게 있습니다. 단, 회사는 원활한 서비스를 위하여 게시물 관리정책 또는 『정보통신망이용촉진 및 정보보호에 관한 법률』, 『청소년 보호법』, 『저작권법』 등의 법률에 따라 일정한 기간 이후에는 공개자 또는 게시자의 동의 없이 게재된 내용을 삭제할 수 있습니다.`,
  `2. 회원이 이용계약을 해지하거나 적법한 사유로 이용계약이 해지 된 경우 회원 게시물의 권리는 회사에 귀속됩니다.`,
  `3. 회원은 관련법령의 규정에서 별도로 정하지 않는 한 서비스에 공개적으로 게재하거나 제출한 자료에 대해 회사에게 비독점적이고 재라이센스 할 수 있는 권한을 부여 하는 것으로 간주 합니다.`,
  `4. 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재된 자료를 영리목적으로 이용하거나 제3자에게 이용하게 할 수 없으며, 공개물 또는 게시물에 대한 저작권 침해는 관계 법령의 적용을 받습니다.`,
  `5. 회원은 회원이 제출한 내용으로 인하여 지적재산권 분쟁이 발생한 경우 회사 및 관계자를 면책 하고 해를 입지 않도록 할 것을 동의합니다.`,
  `6. 본 서비스 또는 서비스와 관련된 소프트웨어는 관련 지적재산권 및 기타 법률에 의해 보호되며, 후원 광고에 포함되어 있는 내용이나 본 서비스 또는 광고주를 통하여 회원에게 제공 되는 정보는 저작권, 상표권, 특허 등 제반 지적재산권 관련 법규에 의해 보호됩니다.`,
  `7. 서비스는 회원에게 한 대의 컴퓨터에서 소프트웨어의 오브젝트 코드를 사용할 수 있는 개인적이고, 양도불가능하며, 비독점적인 권리 및 사용권을 부여합니다. 단, 회원은 소프트웨어를 복사, 수정, 창작물의 제작, 리버스 엔지니어, 리버스 어셈블 또는 소스코드를 발견하려고 시도하거나, 판매, 양도, 재라이센스, 담보권을 설정하거나 소프트웨어상의 어떠한 권리를 달리 양도하여서는 안되며, 제3자로 하여금 위와 같은 행위를 하도록 허락하여서도 안됩니다.`,
  `\n`,
  `제30조 [게시물의 관리]`,
  `1. 회사는 제28조 제1항 각 호에 해당하는 게시물이나 자료를 사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수 있으며, 이에 대해 회사는 어떠한 책임도 지지 않습니다. 또한, 그 게시물의 양과 성격에 따라 서비스 사용 중지 또는 회원자격의 제한을 둘 수 있습니다.`,
  `2. 회사는 게시판에 『정보통신망이용촉진 및 정보보호에 관한 법률』을 위반한 청소년 유해 매체물이 게시되어 있는 경우에는 이를 지체 없이 삭제 합니다. 다만, 만 19세 이상의 회원만 이용할 수 있는 게시판은 예외로 합니다.`,
  `3. 회사가 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 자는 회사에게 당해 정보의 삭제 또는 반박내용의 게재를 요청할 수 있습니다. 이 경우 회사는 지체 없이 필요한 조치를 취하고 이를 즉시 신청인에게 통지합니다.`,
  `4. 회사는 게시물에 관련된 세부 이용지침을 별도로 정하여 시행할 수 있으며, 회원은 그 지침에 따라 각 종 게시물(회원간 전달 포함)을 등록하거나 삭제하여야 합니다.`,
  `5. 회원이 게시하였던 게시물은 자동 삭제 되지 않으므로 삭제를 원할 경우 탈퇴 이전에 삭제하여야 하며, 회사는 회원이 이용계약을 해지하거나 적법한 사유로 이용계약이 해지 된 경우 회원의 게시물을 삭제 또는 별도 관리 할 수 있습니다.`,
  `6. 회원의 게시물이 『정보통신망법 및 저작권법 등 관련 법령』에 위반 되는 내용을 포함할 경우, 해당 권리자는 관련 법령이 정한 절차에 의거하여 해당 게시물의 게시 중단 및 삭제 등을 회사에 요청 할 수 있으며, 회사는 관련 법령에 따른 조치를 취하여야 합니다.`,
  `\n`,
  `\n`,
  `제5장 계약해지 및 기타`,
  `\n`,
  `제31조 [유료 서비스 결제 이용에 관한 해제 및 해지]`,
  `1. 유료서비스 이용계약을 체결한 이용자는 계약체결일로부터 7일 이내에 청약을 철회하거나 해당 계약을 해제(이하 “청약철회등”)할 수 있습니다. 다만, 다음 각 호중 하나에 해당하는 경우에는 이용자의 청약철회등이 제한될 수 있습니다.`,
  `  1-1. 청약의 철회가 불가능한 서비스에 대한 사실을 표시(공지)사항에 포함한 경우`,
  `  1-2. 이용자가 회사가 판단하는 악의적인 목적으로 구매와 취소를 반복하는 경우`,
  `  1-3. 회사가 한시적 또는 일부 이용 등의 방법을 제공한 경우`,
  `  1-4 이용자에게 책임이 있는 사유로 재화 등이 멸실되거나 훼손된 경우 `,
  `  1-5 복제가 가능한 재화 등의 포장을 훼손한 경우 `,
  `  1-6 시간이 지나 다시 판매하기 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우 `,
  `  1-7 용역 또는 콘텐츠의 제공이 개시된 경우 `,
  `  1-8 이용자의 주문에 따라 개별적으로 생산되는 재화 등 또는 이와 유사한 재화 등에 대하여 청약철회등을 인정하는 경우 회사에게 회복할 수 없는 중대한 피해가 예상되는 경우로서 사전에 해당 거래에 대하여 별도로 그 사실을 고지하고 이용자의 서면에 의한 동의를 받은 경우 `,
  `2. 이용자는 다음 각 호의 사유가 있을 때에는 당해 유료서비스를 공급받은 날로부터 7일 이내에 유료서비스 이용계약을 해지할 수 있습니다.`,
  `  1-1. 이용계약에서 약정한 서비스가 제공되지 않는 경우`,
  `  1-2. 제공되는 서비스가 표시, 광고 등과 상이하거나 현저한 차이가 있는 경우`,
  `  1-3. 기타 “콘텐츠”의 결함으로 정상적인 서비스 이용이 현저히 불가능한 경우`,
  `3. 전1항 내지 전2항의 경우에 회원은 언제든지 “고객센터”, “개인정보관리 페이지” 등을 통해서 이용계약을 해지 신청할 수 있으며 회사는 관계법령 등에서 정하는 절차에 따라 이를 신속하게 처리합니다.`,
  `4. 회사는 제3항에 따라 회원이 표시한 계약해제, 해지의 의사표시를 수신한 후 지체 없이 이러한 사실을 회원에게 회신합니다.`,
  `5. 회원은 제2항 2호의 사유로 계약해제, 해지의 의사표시를 하기 전에 상당한 기간을 정하여 서비스이용의 하자에 대한 치유를 요구할 수 있습니다. 다만, 회사가 하자의 치유가 불가능하다고 판단하는 경우에는 즉시 그 사실을 회원에게 통지하고 이용계약을 해제, 해지할 수 있습니다.`,
  `6. 회사는 회원이 제28조에 규정한 회원의 의무를 이행하지 않을 경우 사전 통지 없이 본 서비스 이용 계약을 해지하거나 또는 유료 서비스 이용을 중지 시킬 수 있습니다.`,
  `7. 회원 또는 회사가 유료 결제에 대한 이용계약을 해지할 경우 관련법령 및 개인정보취급방침에서 정하는 바에 따라 일정 기간 저장된 후 파기됩니다.`,
  `\n`,
  `제32조 [이용자의 청약철회등의 효과]`,
  `1. 회사는 회원이 청약철회의 의사표시를 한 날로부터 또는 이용자의 계약해제, 해지의 의사표시에 대하여 회신한 날로부터 10영업일 이내에 대금의 결제와 동일한 방법으로 이를 환불하여야 하며, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에 고지하여야 합니다. 결제대행사를 통한 환불의 경우 대행사의 환불규정에 따릅니다. 다만, 수납확인이나 필요한 결제수단의 경우에는 확인일로부터 10영업일 이내에 이를 환불하도록 합니다.`,
  `2. 회사가 제1항에 따라 회원이 구매한 상품을 중도 해지하여 환불할 경우, 회사는 회원이 유료서비스 이용으로부터 얻은 이익에 해당하는 금액(소비자공급원가 기준)을 공제하고 환급할 수 있습니다.`,
  `3. 회사는 위 대금을 환불함에 있어 회원이 신용카드 또는 전자화폐 등으로 결제를 한 때에는 지체 없이 해당 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다. 다만, 제2항의 금액공제가 필요한 경우에는 그러하지 아니할 수 있습니다.`,
  `4. 계약해제, 해지 요청에 따라 각 결제수단별로 다음 각 호의 방법에 따라 환불하며, 단, 결제수단별 취소가능 기간, 취소 방법 또는 취소 후 조치방법에 차이가 있을 수 있습니다.`,
  `  1-1. 무통장입금의 경우 은행송금수수료를 공제한 잔액을 현금으로 반환합니다.`,
  `  1-2. 휴대폰결제의 경우는 결제한 해당 월내에만 결제 취소 가능합니다.`,
  `  1-3. 각 결제 수단별로 취소 가능 기간이 지난 경우 현금 환불 시에는 환불수수료(상품의10% 와 예매수수료)를 공제한 잔액을 현금으로 반환하며, 환불 금액이 1,000원 미만인 경우와 무상으로 지급된 건은 환불되지 않습니다.`,
  `  1-4. 그 외의 결제수단은 각 결제수단별 결제취소 절차에 따릅니다.`,
  `  1-5. 회원은 회원 탈퇴시 잔여 마일리지는 탈퇴신청 전에 소진하여야 하며 회원탈퇴 후에는 자동으로 소멸되어 환불신청이 불가능합니다.`,
  `  1-6. 회원이 제11조, 제12조에 해당하는 행위를 하였을 경우, 회사가 계약을 해제 또는 해지하거나 서비스 이용을 제한 한 후 환불해야 할 금액이 있을 경우에는 본 조 제2항, 제3항에서 정한 환불 기준을 적용하여 공제하고 환불합니다. 이 경우 회원은 해당 조치에 대하여 회사가 정한 절차에 따라 이의 신청을 할 수 있으며, 회사는 정당하다고 인정하는 경우 즉시 서비스 이용 재개 등을 합니다.`,
  `  1-7. 시스템상의 장애로 인해 결제 후 유료 서비스 이용이 안되는 경우, 회사는 결제를 취소하거나 결제수단에 따라 결제취소가 불가능한 경우 이용자에게 공지하고 대금의 결제와 동일한 방법으로 환불을 하여야 합니다.`,
  `  1-8. 회사는 “콘텐츠 등의 대금을 지급 받은 자” 또는 “이용자와 콘텐츠이용계약을 체결한 자“가 동일인이 아닌 경우에 각자는 청약철회 또는 계약해제, 해지로 인한 대금환급과 관련한 의무의 이행에 있어서 연대하여 책임을 집니다.`,
  `  1-9. 회사는 회원에게 청약철회를 이유로 위약금 또는 손해배상을 청구하지 않으며, 회원의 계약 해제, 해지는 손해배상의 청구에 영향을 미치지 않습니다. 단, 이용기간을 약정한 상품에 대한 해지에 대해서는 위약금이 청구될 수 있습니다.`,
  `\n`,
  `제33조 [회사의 계약해제, 해지 및 이용제한]`,
  `1. 회사는 회원이 제12조, 제13조에서 정한 행위를 하였을 경우 사전통지 없이 계약을 해제, 해지하거나 또는 기간을 정하여 서비스 이용을 제한할 수 있습니다.`,
  `2. 제1항의 해제, 해지는 회사가 정한 통지방법에 따라 회원에게 그 의사를 표시한 때에 효력이 발생합니다.`,
  `3. 회사의 해제, 해지 및 이용제한에 대하여 회원은 회사가 정한 절차에 따라 이의 신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우, 회사는 즉시 서비스의 이용을 재개합니다.  `,
  `\n`,
  `제34조 [회사의 계약해제, 해지의 효과]`,
  `회원의 귀책사유에 따른 이용계약의 해제, 해지의 효과는 회사가 정한 회원약관의 내용에 준용합니다. 다만, 회사는 이용자에 대하여 계약 해제, 해지의 의사표시를 한 날로부터 10영업일 이내에 대금의 결제와 동일한 방법으로 이를 환급합니다.`,
  `\n`,
  `제35조 [과오금]`,
  `1. 회사는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금 전액을 환불하여야 합니다. 다만, 동일한 방법으로 환불이 불가능할 때는 이를 사전에 고지합니다.`,
  `2. 회사의 책임 있는 사유로 과오금이 발생한 경우 회사는 계약비용, 수수료 등에 관계없이 과오금 전액을 환불합니다. 다만, 이용자의 책임 있는 사유로 과오금이 발생한 경우, 회사가 과오금을 환불하는 데 소요되는 비용은 합리적인 범위 내에서 이용자가 부담하여야 합니다.`,
  `3. 이용자의 월정액 결제 이용 대금이 적게 과금 된 경우 회사는 이용자와의 상호 합의하에 차액을 요구할 수 있습니다.`,
  `4. 회사는 이용자가 주장하는 과오금에 대해 환불을 거부할 경우에 정당하게 이용대금이 부과되었음을 입증할 책임을 집니다.`,
  `5. 회사는 과오금의 환불절차를 『디지털콘텐츠 이용자보호지침』에 따라 처리합니다.`,
  `\n`,
  `제36조 [콘텐츠하자 등에 의한 이용자피해보상]`,
  `회사는 콘텐츠하자 등에 의한 이용자피해보상의 기준,범위,방법 및 절차에 관한 사항을 『디지털콘텐츠 이용자보호지침』에 따라 처리합니다.`,
  `\n`,
  `제37조 [보증의 부인]`,
  `1. 본 서비스를 이용하여 어떠한 자료를 다운로드 또는 스트리밍하는 행위는 회원의 판단 및 위험에 의해 행하여지고, 그러한 자료와 다운로드로 인해 초래되는 컴퓨터 시스템에 대한 손해 및 데이터 손실에 대해서는 회원이 전적으로 책임을 부담합니다.`,
  `2. 회원이 본 서비스를 통하여 취득한 구두 또는 문서상의 모든 충고와 정보에 대하여서는 본 약관에 명시적으로 규정되어 있지 않은 어떠한 보증도 제공되지 않습니다.`,
  `\n`,
  `제38조 [양도 금지]`,
  `회원은 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여할 수 없으며 게시물 등 모든 형태의 공개자료에 대한 저작권을 포함한 모든 권리 및 책임은 이를 공개한 회원에게 있습니다.`,
  `\n`,
  `\n`,
  `제6장 손해배상 등`,
  `\n`,
  `제39조 [손해배상]`,
  `1. 본 서비스는 회원의 편의를 위하여 제공하는 서비스로, 본 서비스와 관련된 부과금액 등 이용요금이 무료인 동안에는 본 서비스 이용과 관련하여 발생한 어떠한 손해에 대하여도 회사가 책임을 지지 않습니다.`,
  `2. 회원이 본 약관을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.`,
  `3. 회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 “회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책 시켜야 하며, 회사가 면책되지 못한 경우 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다.`,
  `4. 회사 제공 서비스 및 유료 결제 서비스등의 제공과 관련하여 회사의 귀책사유로 인하여 회원이 서비스 이용에 손해를 입은 경우, 회원은 회사 제공 서비스 복구 등 합당하고 적절한 보상을 받을 수 있습니다.`,
  `\n`,
  `제40조 [면책사항]`,
  `1. 회사는 다음 각 호의 1에 해당하는 사유로 인하여 회원 또는 제3자에게 발생한 손해에 대하여는 그 책임을 지지 아니합니다.`,
  `  1-1. 천재지변 또는 이에 준하는 불가항력으로 인해 서비스를 제공할 수 없는 경우`,
  `  1-2. 회원이 자신의 ID 또는 비밀번호 등의 관리를 소홀히 하는 등 타인의 부정사용을 방치한 경우`,
  `  1-3. 회원이 제3자의 ID, 비밀번호, 휴대폰, 계좌, 신용카드 번호 등 개인정보를 도용하여 제3자에게 손해를 발생시킨 경우`,
  `  1-4. 회사의 관리 영역이 아닌 공중통신선로의 장애로 서비스 이용이 불가능한 경우`,
  `  1-5. 기타 회사의 귀책 사유가 없는 통신서비스 등의 장애로 인한 경우`,
  `2. 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며 그 밖에 서비스를 통하여 얻은 자료로 인한 손해 등에 대하여도 책임을 지지 않습니다.`,
  `3. 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다.`,
  `4. 회사는 서비스 이용과 관련하여 회원에게 발생한 손해 가운데 회원의 고의, 과실에 의한 손해에 대하여 책임을 지지 않습니다.`,
  `5. 회사는 회원 상호간 또는 회원과 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.`,
  `\n`,
  `제41조 [관할법원]`,
  `1. 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 쌍방간에 분쟁의 해결을 위해 성실히 협의한 후가 아니면 제소할 수 없습니다.`,
  `2. 본 조 제1항의 협의에서도 분쟁이 해결되지 않을 경우 회사와 회원간의 콘텐츠 이용계약에 관한 『민사소송법』상의 관할법원에 소를 제기할 수 있습니다.`,
  `\n`,
  `부칙 (시행일)`,
  `본 약관은 2025년 1월 10일부터 적용합니다.`,
  `\n`,
]
